import React from "react";
import { html } from 'lit';
import { Om2Dropdown } from "omni-campaign-ui";

// Shared components and utilities
import { 
    OmniDropdownComponent, 
    OmniTableComponent, 
    OmniIconComponent, 
    OmniCheckboxComponent, 
    OmniTooltipNextComponent, 
    AccordionComponent, 
    BuyCategoryOrMerketplace, 
    BuyType, 
    Providers, 
    UnitDimentions, 
    UnitType, 
    Marketplace, 
    DimensionsPosition, 
    impressionsMethod, 
    messages, 
    Utils, 
    AlertMessagesService, 
    LoaderComponent,
    trackEvent
} from "../../../../shared";

// Feature imports
import { PlacementUtils, PlacementDetailsTableService, CreatePlacementOrPackageService, CreateLineAndChildPlacementTable, SmartSuggestionBanner, SmartSuggestionPanel } from "../../";
import { CreateTaxonomyService } from "../../../taxonomy";
export class PlacementsDialogComponent extends React.Component {
  defaultState = {
    emptyFieldError: false,
    validationFlag : false,
    formData: {
      "Placement Name": "",
      "Parameter Code" : "",
      "Flight Start": "",
      "Flight End": "",
      "costMethod": "",
      "Rate": "",
      "Unit Amount": "",
      "Planned Cost": "",
      "adserverfee": "",
      "adverificationfee": "",
      "Parameter Code Ad Server":'',
      "Parameter Code Ad Verification":'',
      'selectedFormDataAbbrevation': {},
      "overrideAdservingFees": false,
      "overrideAdverificationFees": false,
      "isAddMarkup": false,
      "billableRate": "",
      "billable": "",
      "margin": "",
      "markupPercent": ""
    },
    'programmaticPackageData':null,
    spinnerCount: 1,
    taxonomyData: null,
    campaignTaxonomyData:null,
    touchedFields: {}, // Track which fields have been interacted with
    showSmartSuggestions: false,
    smartSuggestionPanelOpen: false,
    smartSuggestionsData: null
  };
  
  defaultRequiredFields = ["Flight Start","Flight End"]
  formData = {};
  fieldIsUpdated = false;
  isSaveDisabled = true;
  loaded = false;
  requiredFields = [...this.defaultRequiredFields];
  taxonomyAccordions = [];
  synthecticId = '-'
  budgetData = [];
  planedCost = null;
  placementType = '';
  publisherName = '';
  currentPlacementName = '';
  remainingProgramticPackageCost = null;
  parentChildPlacements = [];
  feeCalcParam = "";
  updatedTaxonomyData = {};
  moErrorFields = {};

  // Variables for Cascading fields
  origTaxonomyData = {}
  origDefaultTaxonomyData = {}
  cascadingMap = {};
  placementMaxCharLimit = 256;

  DirectProgrammaticTypes = ['Package', 'Print Offline Package', 'DOOH Package', 'Cinema Offline Package', 'Other Offline Package', 'Unallocated Offline Package', 'National TV Network Package', 'Network Radio Offline Package', 'Spot TV Offline Package', 'Spot Radio Offline Package'];
  DirectProgrammaticMainTypes = ['Direct', 'Social Direct', 'Print', 'OOH', 'Cinema', 'Other', 'Unallocated', 'National TV', 'Network Radio', 'Spot TV', 'Spot Radio'];

  constructor(props) {
    super(props);    
    if (!this.loaded) {
      this.state = {
        isPlacementModalOpen: props.isPlacementModalOpen,
        formData: {
          "Placement Name": "",
          "Flight Start": "",
          "Flight End": "",
          "costMethod": "",
          "Rate": "",
          "Unit Amount": "",
          "Planned Cost": "",
          "adserverfee": "",
          "adverificationfee": "",
          "overrideFees": false,
          "Parameter Code Ad Server":'',
          "Parameter Code Ad Verification":'',
          'selectedFormDataAbbrevation': {}
        },
        spinnerCount: 0,
        taxonomyData:{},
        defaultTaxonomyData: props?.allTaxonomyData?.defaultTaxonomyData,
        errorForm: {},
        campaignTaxonomyData:props.campaignTaxonomyData,
        touchedFields: {} // Track which fields have been interacted with
      };
      Om2Dropdown.register();
      this.loadDD();
      this.loaded = true;
    }
    this.onDataChange = this.onDataChange.bind(this);
  }

  loadDD = () => {
    this.buyType = BuyType;
    this.buyCategoryOrMerketplace = BuyCategoryOrMerketplace;
    this.marketplace = Marketplace;
    this.unitDimentions = UnitDimentions;
    this.providers = Providers;
    this.unitTypeOptions = UnitType;
    this.dimentionsPostion = DimensionsPosition;
  };

  componentDidMount = () => {
       this.onModalOpen(this.props);
  
       const { editDailog, computeSmartSuggestions, placementData } = this.props;
       const isCreateDialog = !editDailog;
       const isPlanitEditDialog = editDailog && 
                                  placementData?.data_source === 'planit' && 
                                  placementData?.pmds_package_name;
       const shouldLoadSmartSuggestions = computeSmartSuggestions && 
                                          (isCreateDialog || isPlanitEditDialog);

       // Lazy load smart suggestions for create dialog when placement category is selected
       if (shouldLoadSmartSuggestions) {
         const placementType = this.props.placementCategory?.type;
         const taxonomyData = this.props.placementCategory?.title ? this.props.placementTaxonomyMap[this.props.placementCategory.title][this.props.placementCategory.type] : {};

         if (placementType) {
           // Call lazy loader with callback
           const suggestions = this.props.computeSmartSuggestions(placementType, taxonomyData, (loadedSuggestions) => {
             // Callback when async computation completes
             this.setState({ 
               smartSuggestionsData: loadedSuggestions,
               showSmartSuggestions: !!loadedSuggestions
             });
           });
           
           // Handle immediate result:
           // - undefined = loading (computation in progress, don't show banner yet)
           // - null = no data found (user has 0 placements)
           // - object = has suggestions data
           if (suggestions !== undefined) {
             // Already cached - either has data or explicitly no data
             this.setState({ 
               smartSuggestionsData: suggestions,
               showSmartSuggestions: !!suggestions
             });
           }
           // If undefined (loading), we wait for callback - no loading state shown
         }
       }
  }
  
  componentDidUpdate(prevProps, prevState) {
   if (prevProps.placementCategory.title !== this.props.placementCategory.title || this.state.isPlacementModalOpen != this.props.isPlacementModalOpen) {
    this.setState({ isPlacementModalOpen:this.props.isPlacementModalOpen});
    
          this.onModalOpen(this.props);
    }

     // Remove automatic validation on taxonomy load for create forms
    if (!prevState.taxonomyData?.fields && this.state.taxonomyData?.fields) {
      // Only validate for edit forms
      if (this.props.editDailog) {
        this.checkAndValidate();
      }
    }
    
    // Check if form data was updated and user has interacted
    if (prevState.formData !== this.state.formData && Object.keys(this.state.touchedFields).length > 0) {
      this.checkAndValidate();
    }
  }
  
  // Add this helper method
  checkAndValidate = () => {
    // Wait until both data sources are available
    if (!this.state.taxonomyData?.fields || !this.state.loaded) {
      return;
    }
    
    this.validateAllFieldsOnLoad();
  }

  /**
   * This function is used to prepopulate the taxonomy fields values from parent to child during placement creation.
   * @param parentField - this parameter is a string having the field name to be prepopulated.
   * @param parentValue - this parameter is a string/number having the field value to be prepopulated.
   * @param DefaultData  - the data object contains all the form data
   * @param taxonomyFields - this parameter is an array of objects having the taxonomy fields.
   */
  populateTaxonomyValues = (parentField, parentValue, DefaultData, taxonomyFields) => {
    if (taxonomyFields) {
      taxonomyFields.forEach((propsData) => {
            if(propsData.name === parentField && propsData.field_type === 1){
                propsData.fielditems.every((fieldOption)=>{
                  if(fieldOption.code?.trim()?.toLowerCase() === parentValue?.trim()?.toLowerCase()){
                    DefaultData[propsData.name] = parentValue;
                    return false;
                  }
                  return true;
                })
            } else if(propsData.name === parentField && propsData.field_type !== 10){ // field_type 10 is for taxonomy field and we shouldn't update the value for taxonomy field
              DefaultData[propsData.name] = parentValue;
            }
      })
    }
  }

  /**
   * The `componentProps` function is a lifecycle method in a React component that updates
   * the component's state based on new props received.
   * @param props - The `props` parameter is an object that contains various properties and values. It
   * is passed to the `componentProps` function as an argument. The specific properties used
   * in the function are:
   */
  onModalOpen(props) {
    const isLocal = props.systemParametersData.data.isLocal;
    const currency = isLocal && props.campaignObj.local_currency_name ? props.campaignObj.local_currency_name : 'USD';
    let taxonomyData = this.props.placementCategory?.title ? props.placementTaxonomyMap[this.props.placementCategory.title][this.props.placementCategory.type] : {};
    this.setState({ taxonomyData: this.props.placementCategory.type === "Fee" ? props?.allTaxonomyData['feeOrderTaxonomyData'] : taxonomyData }, () => {
      this.updatedTaxonomyData = props.placementCategory?.title ? props.placementTaxonomyMap[props.placementCategory?.title][props.placementCategory?.type] : {};
      let DefaultData = { ...this.defaultState.formData };
      // let taxonomyData = this.state.taxonomyData ? { ...this.state.taxonomyData } : null;
      this.origTaxonomyData = taxonomyData;
      this.origDefaultTaxonomyData = props.allTaxonomyData?.defaultTaxonomyData;
      this.createCascadingMap();

      if (props.editDailog === true) {
        // this is for edit placement
        let placementData = props.placementData;
        this.synthecticId = placementData.placements_id;
        this.updaterequiredFields(props, placementData.override_taxonomy);
       
        let { schemaArr, editFormData } = PlacementDetailsTableService.getFormEditData(taxonomyData?.fields, placementData);
        this.populateEditForm(schemaArr, editFormData, DefaultData, placementData, isLocal, currency);
        this.setDisabledFields(taxonomyData, placementData, DefaultData);
        if(placementData.pmds_package_name && !placementData.placement_taxonomy_display){
          this.prepareCreateTaxonomyFields(props, taxonomyData, DefaultData);
        }
        let plannedCostield = isLocal && currency ? 'planned_cost_local' : 'planned_cost';
        this.placementType = placementData["Channel"];
        this.publisherName = placementData["Publisher"];
        this.planedCost = placementData[plannedCostield];
        if (this.placementType && this.publisherName) {
          this.createBudgetTableData(this.planedCost, this.placementType, this.publisherName);
        }

        if (placementData.package_type === "ProgrammaticPackage") {
          this.getProgramaticPayload(DefaultData);
          DefaultData["isOverride"] = placementData?.override_taxonomy;
          this.setState({ parentChildPlacements: placementData.nestedData });
        }
        CreatePlacementOrPackageService.updatePdmsDataInPlacementTaxonomyFields(schemaArr, DefaultData, placementData, this.state.taxonomyData?.fields)
        CreatePlacementOrPackageService.updatePdmsDataInParameterCodeTaxonomyFields(DefaultData, placementData, this.state.defaultTaxonomyData?.fields)

        // Check for MO Error Data and update the MO Error Fields if present to show the error message
        if(placementData.moErrorData){
          this.moErrorFields.isMoEdit = true;
          let errorMsgArr = placementData.moErrorData.msg.split(";");
          errorMsgArr.forEach((error) => {
            this.moErrorFields[PlacementUtils.getMOErrorFields(error.split(":")[0])] = error.split(":")[1]; 
          });
        } else {
          this.moErrorFields = {};
        }
      }
      else {
        // this is for create placement
        this.updaterequiredFields(props, false);
        this.synthecticId = '-'
        this.defaultState.formData["Placement Name"] = '';
        let fieldNamesArr = [];
        
        // Note: Smart suggestions are loaded lazily in componentDidMount
        // No need to set anything here - async loading will handle it
        
        this.prepareCreateTaxonomyFields(props, taxonomyData, DefaultData);
        this.prepareCreateDefaultTaxonomyFields(props, DefaultData, fieldNamesArr);
        this.populateFieldIfSelected(props, DefaultData, taxonomyData);
        this.populateChildFieldsBasedOnParent(props, DefaultData, taxonomyData, fieldNamesArr);

        let buyType = DefaultData.selectedFormDataAbbrevation['Parameter Code Buy Type'] ? DefaultData.selectedFormDataAbbrevation['Parameter Code Buy Type'] : DefaultData['Parameter Code Buy Type'];
        let adOptions = this.setAdOptions(buyType);
        if (!DefaultData['Parameter Code Ad Server']) {
          DefaultData['Parameter Code Ad Server'] = adOptions ? adOptions?.adServingMatchedValue?.value : '';
        }
        if (!DefaultData['Parameter Code Ad Verification']) {
          DefaultData['Parameter Code Ad Verification'] = adOptions ? adOptions?.adVerificationMatchedValue?.value : '';
        }
        this.moErrorFields = {};
      }
      this.setState({ formData: DefaultData, taxonomyData: taxonomyData, spinnerCount: 0, defaultTaxonomyData: props.allTaxonomyData?.defaultTaxonomyData }, () => {
        this.placementMaxCharLimit = taxonomyData?.totalCharLimit < this.placementMaxCharLimit ? taxonomyData?.totalCharLimit : this.placementMaxCharLimit;
        this.isFormDirty(DefaultData, props);
        this.checkForCascadingFields(DefaultData, null);
        // need to confim why we use this
        if (props.taxonomyData !== this.props.taxonomyData) {
          this.loadTaxanomyAccordion();
        }
        // Check for override value and update the placement name
        if(props.placementData?.override_taxonomy && props.editDailog){
          this.overridePlacementName();
        }
      });
    });
  };

  
  /**
   * This function is used to create cascading mapping  between the fields.
   * This will help in checking the cascading values and updating the child dropdowns.
   */
  createCascadingMap = () => {
    this.cascadingMap = {};
    PlacementUtils.populateExplicitCascadingMap(this.origTaxonomyData, this.cascadingMap);
    PlacementUtils.populateExplicitCascadingMap(this.origDefaultTaxonomyData, this.cascadingMap);
  }


  /**
   * Function to check cascading fields and update the child dropdowns.
   * @param {object} DefaultData - The object conmtains all the form data.
   * @param {string} value - The dropdoan value to be checked for cascading fields.
   * @returns {void}
  */ 
  checkForCascadingFields = (DefaultData, value = null) => {   
    let taxonomyData = this.state.taxonomyData;
    let defaultTaxonomyData = this.state.defaultTaxonomyData;
    const fields = taxonomyData?.fields?.filter(field => !field?.hidden);

    for (let i = 0; i < fields?.length; i++) {
      let isValidField = fields[i].fielditems.filter((x) => x?.code.trim() === (value ? value : DefaultData[fields[i].name]));      
      if(isValidField.length) {        
          this.placementFieldsCascading(isValidField, DefaultData, true);
      }
    }

    for (let i = 0; i < defaultTaxonomyData?.fields?.length; i++) {
      let isValidField = defaultTaxonomyData.fields[i].fielditems.filter((x) => x?.code.trim() === (value ? value : DefaultData["Parameter Code " + defaultTaxonomyData.fields[i].name]));
      if(isValidField.length) {
          this.placementFieldsCascading(isValidField, DefaultData, true);
      }
    }
  }


  /** 
  * This function is used to populate the edit form fields from the placement data.
  * The below code is splitting the values of two properties, "parameter_code" and "parameter_code_taxonomy_schema", 
  * from an object called "placementData" using a delimiter. It then iterates over the resulting arrays and 
  * assigns the values to corresponding keys in an object called "DefaultData". The keys are generated by concatenating the string "Parameter Code" 
  * with the values from the "parameter_code_taxonomy_schema" array. 
  * @param schemaArr - The `schemaArr` parameter is an array that contains the schema of the placement data.
  * @param editFormData - The `editFormData` parameter is an object that contains the placement data to be filled in the edit form.
  * @param DefaultData - The `DefaultData` parameter is an object that contains the default form data & use to update the edit form.
  * @param placementData - The `placementData` parameter is an object that contains the edit placement data.
  */ 
  populateEditForm = (schemaArr, editFormData, DefaultData, placementData,isLocal, currency) => {
    if (!placementData["override_taxonomy"]) {
      for (const index of schemaArr) {
        DefaultData[index] = editFormData[index];
      }
    }
    let parameterEditFormData = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(placementData["parameter_code"], placementData["parameter_code_taxonomy_schema"], this.state.defaultTaxonomyData?.fields);
    let parameterSchema = (placementData["parameter_code_taxonomy_schema"] || "").split("|");
    for (let index in parameterSchema) {
      DefaultData["Parameter Code " + parameterSchema[index]] = parameterEditFormData[parameterSchema[index]];
    }
    if(placementData.data_source === 'planit' || placementData.pmds_package_name){
      DefaultData['PMDS Name'] = placementData.pmds_package_name;
      DefaultData['TierId'] = placementData.tier_id;
    }
    DefaultData["Parameter Code"] = placementData["parameter_code"];
    DefaultData["Flight Start"] = placementData["flight_start"] ? Utils.formatDateObject(placementData["flight_start"]) : "";
    DefaultData["Flight End"] = placementData["flight_end"] ? Utils.formatDateObject(placementData["flight_end"]) : "";
    let rateField = isLocal && currency ? 'rate_local' : 'rate';
    let plannedCostield = isLocal && currency ? 'planned_cost_local' : 'planned_cost';
    DefaultData["Rate"] = (placementData[rateField] || placementData[rateField] === 0)  ? placementData[rateField] : "";
    DefaultData["Unit Amount"] = (placementData["unit_amount"] || placementData["unit_amount"] === 0) ? placementData["unit_amount"] : "";
    DefaultData["Planned Cost"] = (placementData[plannedCostield] || placementData[plannedCostield] === 0) ? placementData[plannedCostield] : "";
    DefaultData["costMethod"] = placementData["cost_method"];
    DefaultData["isAddMarkup"] = placementData["billable"];
    DefaultData["billable"] = placementData["billable"] ? placementData["billable"] : "";
    DefaultData["billableRate"] = placementData["billable_rate"] ? placementData["billable_rate"] : "";
    DefaultData["margin"] = placementData["margin"] ? placementData["margin"] : "";
    DefaultData["markupPercent"] = placementData["margin_percentage"] ? placementData["margin_percentage"] : "";
    DefaultData["adserverfee"] = placementData["ad_server_fee"] ? placementData["ad_server_fee"] : "";
    DefaultData["adverificationfee"] = placementData["ad_verification_fee"] ? placementData["ad_verification_fee"] : "";
    DefaultData["overrideAdservingFees"] = placementData["is_ad_server_fee_override"];
    DefaultData["overrideAdverificationFees"] = placementData["is_ad_verification_fee_override"];
    let placementNameArray = placementData["placement_taxonomy"]?.split(':|');    
    DefaultData["Placement Name"] = placementNameArray ? placementNameArray[0] : '';
    //Assign value to CPC Calculation Type, if CPC selected parameter "cost method"
    DefaultData["CPC Calculation Type"] = this.getCpcCalculationType(DefaultData["costMethod"], placementData['cpc_calc_type']);

    // Remove validation call for edit forms on load  
    // After all data is set and state is updated
    // setTimeout(() => {
    //   this.validateAllFieldsWithUI();
    // }, 300); // Small delay to ensure state is fully updated
  }

  validateAllFieldsWithUI = () => {
    const hasErrors = this.validateAllFieldsOnLoad();
    
    if (hasErrors) {
      // Force UI update for immediate error display
      this.forceUpdate();
    }
  }

  /** 
  * This function is used to set the disabled fields in the edit form.
  * The below code is mapping over an array of fields in the `taxonomyData`. 
  * For each field, it checks if the field type is 10. If it is, it assigns the value of the `placementData.id` property to the field.
  * It also prpagate the default taxonomy data to the form data and set the disabled property to true for the specified field.
  * It then sets the `disabled` property of the others field to false. Finally, it returns the modified field.
  * @param taxonomyData - The `taxonomyData` parameter is an object that contains the taxonomy data.
  * @param placementData - The `placementData` parameter is an object that contains the placement data.
  * @param DefaultData - The `DefaultData` parameter is an object that contains the default form data.
  */ 
  setDisabledFields = (taxonomyData, placementData, DefaultData) => {
    this.state.defaultTaxonomyData?.fields.map((field) => {
      field.mandatory = false
      if (placementData.parent_id && (field.name === 'Publisher' || field.name === 'Supplier Code' || field.name === 'Supplier' || field.name === 'Buy Type')) {
        field.disabled = true;
      } else {
        field.disabled = false;
      }
      return field;
    });
  }

  /** 
  * This function is used to prepare the create taxonomy fields.
  * The below code is mapping over an array of fields in the `taxonomyData`.
  * For each field, it checks if the field type is 2. If it is, it assigns an empty string to the field.
  * If the field type is 9, it assigns the value of the `static_field_value` property to the field.
  * If the field type is 10, it assigns the value of the `TaxonomyValueID` property to the field.
  * If the field is recommended, it assigns the value 'NU' to the field.
  * It also removes any disabled value set in the field and set the 'Channel' & 'Publisher' field based on selected placement type.
  * @param props - The `props` parameter is an object that contains the props.
  * @param taxonomyData - The `taxonomyData` parameter is an object that contains the taxonomy data.
  * @param DefaultData - The `DefaultData` parameter is an object that contains the default form data.
  */ 
  prepareCreateTaxonomyFields = (props, taxonomyData, DefaultData) => {
    if (taxonomyData?.fields && taxonomyData?.fields.length > 0) {
      taxonomyData.fields.forEach((field) => {
        if (field.field_type === 2) {
          DefaultData[field.name] = '';
        }
        if (field.field_type === 9) {
          DefaultData[field.name] = field.static_field_value;
        }
        if (field.field_type === 10) {
          DefaultData[field.name] = "{TaxonomyValueID}"
        }

        if (field?.field_type === 3) {
          if (field?.taxonomy_id === this.props.allTaxonomyData['campaignTaxonomyData']?.id) {
            if (field?.display_code?.toLowerCase() === 'u') {
              DefaultData[field.name] = this.props?.campaignObj?.campaign_taxonomy_display?.split(':')[0];
            } else if (field?.display_code?.toLowerCase() === 'c') {
              DefaultData[field.name] = this.props?.campaignObj?.campaign_taxonomy?.split(':')[0];
            } else if (field?.display_code?.toLowerCase() === 'i') {
              const taxonomyIdField = this.props.allTaxonomyData?.['campaignTaxonomyData']?.fields?.filter((item) => item.field_type === 10);
              const taxonomyIdFieldInCampaignObj = this.props?.campaignObj?.taxonomy?.filter((item) => item.id === taxonomyIdField[0]?.id);
              DefaultData[field.name] = taxonomyIdFieldInCampaignObj ? taxonomyIdFieldInCampaignObj[0]?.code : '';
            }
          }
        }

        // set NU as default value for recommended fields
        if (field.recommended) {
          DefaultData[field.name] = 'NU';
        }
        // remove any disabled value set in field
        field.disabled = false

        this.props.placementNestedData?.map(channelValue => {
          channelValue.nestedData && channelValue.nestedData.map(publisherValue => {
            if (publisherValue.checked !== undefined && publisherValue.checked === true) {
              if (field.name === 'Publisher') {
                field.fielditems.map((item) => {
                  if (item.name === publisherValue.placement_taxonomy) {
                    DefaultData[field.name] = item.code;
                  }
                })
              }
            }
          })
        })

        if (field.name === 'Channel' || field.alias === 'Channel') {
          field.fielditems.map((item) => {
            if (item?.name === 'Programmatic' && props?.placementCategory?.type === 'Programmatic') {
              DefaultData[field.name] = item.code;
            } else if (item.name === 'Social' && props?.placementCategory?.type?.includes('Social')) {
              DefaultData[field.name] = item.code;
            } else if (item.name === props?.placementCategory?.type) {
              DefaultData[field.name] = item.code;
            }
          })
        }
        this.populateCampaignData(props, DefaultData, field);
      });
    }
  }

  /**
  * Splits the campaign taxonomy into an array and maps over the campaign taxonomy data fields.
  * For each field, it checks if the field name, alias, or id matches the current item's name, alias, or id.
  * If a match is found, it checks if any of the field items' name or code matches the campaign field name.
  * If a match is found, it sets the DefaultData's field name to the campaign field name.
  * @param {Object} props - The properties passed to the component, including campaignObj and campaignTaxonomyData.
  * @param {Object} DefaultData - The object to update with the campaign field name.
  * @param {Object} field - The field to check against each item.
  */
  populateCampaignData = (props, DefaultData, field) => {
    const campaignNameArr = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(props.campaignObj['campaign_taxonomy'], props.campaignObj['taxonomy_schema'], props.campaignTaxonomyData?.fields, ':|');
    props.campaignTaxonomyData?.fields.map((item) => {
      if (field.id === item.id || field.name === item.name) {
        const campaignFieldName = campaignNameArr[item.name] || campaignNameArr[item.alias];
        if ((field?.field_type === 1 || field?.field_type === 7) && field?.fielditems?.some((fieldItem) => fieldItem?.code === campaignFieldName)) {
          DefaultData[field.name] = campaignFieldName;
        } else if(field?.field_type === 2 || field?.field_type === 6){
          DefaultData[field.name] = campaignFieldName;
        }else if (field?.field_type === 5 && !['', 'nu'].includes(campaignFieldName?.toLowerCase())) {
          DefaultData[field.name] = campaignFieldName;
        }
      }
    });
  }

  /**
   * This function is used to populate the buy type based on the create type.
   * It assigns the value based on the selected parent or the create type.
   * @param props - The `props` parameter is an object that contains the props.
   * @param DefaultData - The `DefaultData` parameter is an object that contains the default form data.
   * @param field - The `field` parameter is an object that contains the field data.
  */ 
  populateBuyTypeBasedOnCreateType = (props, DefaultData, field) => {
    this.props?.placementNestedData?.map(channelValue => {
      if (channelValue.checked !== undefined && channelValue.checked === true) {
        if (field.name === 'Buy Type') {
          field.fielditems.map((item) => {
            if (item.name === channelValue.placement_taxonomy) {
              DefaultData["Parameter Code " + field.name] = item.code;
              this.placementFieldsCascading([item], this.state.formData);
            }
          })
        }
      }
      channelValue.nestedData && channelValue.nestedData.map(publisherValue => {
        if (publisherValue.checked !== undefined && publisherValue.checked === true) {
          if (field.name === 'Site') {
            field.fielditems.map((item) => {
              if (item.name === publisherValue.placement_taxonomy) {
                DefaultData["Parameter Code " + field.name] = item.code;
              }
            })
          }
        }
      })
    });
    if (field.name === 'Buy Type' || field.alias === 'Buy Type') {
      field.fielditems.map((item) => {
        if (item.name === 'Programmatic' && props?.placementCategory?.type === 'Programmatic') {
          DefaultData["Parameter Code " + field.name] = item.code;
        } else if ((item.name === 'Paid Social' || item.code === 'Social') && (props?.placementCategory?.type?.includes('Social'))) {
          DefaultData["Parameter Code " + field.name] = item.code;
          field.disabled = true;
          this.placementFieldsCascading([item], this.state.formData)
        } else if (item.name === 'Fee' && props.placementCategory.type === "Fee") {
          DefaultData["Parameter Code " + field.name] = item.code;
        } else if (item.name === props?.placementCategory?.type || item.name === props?.placementCategory?.channel) {
          DefaultData["Parameter Code " + field.name] = item.code;
        }
      })
      if(DefaultData["Parameter Code " + field.name]) field.disabled = true;
    }
  }

  /**
   * This function is used to prepare the create default taxonomy fields.
   * The below code is mapping over an array of fields in the `defaultTaxonomyData`.
   * For each field, it checks if the field type is 2. If it is, it assigns an empty string to the field.
   * If the field is recommended, it assigns the value 'NU' to the field.
   * It also removes any disabled value set in the field and set the 'Buy Type' field based on selected placement type and pish it to fieldNamesArr.
   * @param props - The `props` parameter is an object that contains the props.
   * @param DefaultData - The `DefaultData` parameter is an object that contains the default form data.
   * @param fieldNamesArr - The `fieldNamesArr` parameter is an array that contains the field names.
   */ 
  prepareCreateDefaultTaxonomyFields = (props, DefaultData, fieldNamesArr) => {
    this.state.defaultTaxonomyData?.fields.forEach((field) => {
      field.mandatory = false
      fieldNamesArr.push("Parameter Code " + field.name);
      if (field.field_type === 2) {
        DefaultData["Parameter Code " + field.name] = '';
      }
      if (field.recommended) {
        DefaultData["Parameter Code " + field.name] = 'NU';
      }
      field.disabled = false;

      this.populateBuyTypeBasedOnCreateType(props, DefaultData, field);
      
      // Check for the default taxonomy field name in campaign object, If it exists, then set the default data to the campaign object field value.
      if (props.campaignObj[field.name]) {
        DefaultData["Parameter Code " + field.name] = props.campaignObj[field.name];
      }
    });

    fieldNamesArr.push('overrideAdservingFees');
    fieldNamesArr.push('overrideAdverificationFees');
    this.defaultRequiredFields.forEach((fieldName) => {
      fieldNamesArr.push(fieldName);
      // Set the default data start & end Date to the campaign object start & end date field value.
      if (fieldName === 'Flight Start')
        DefaultData[fieldName] = Utils.formatDateObject(props.campaignObj['start_date'])
      if (fieldName === 'Flight End')
        DefaultData[fieldName] = Utils.formatDateObject(props.campaignObj['end_date'])
    });
    fieldNamesArr.push(...["Parameter Code Ad Server", "Parameter Code Ad Verification"]);
  }

  /**
   * This function is used to populate the field if any placement is selected.
   * The below code is checking if the selected placement is valid and populating the default data.
   * @param props - The `props` parameter is an object that contains the props.
   * @param DefaultData - The `DefaultData` parameter is an object that contains the default form data.
   * @param taxonomyData - The `taxonomyData` parameter is an object that contains the taxonomy data.
   */  
  populateFieldIfSelected = (props, DefaultData, taxonomyData) => {
    let selectedPrPkg;
    const isLocal = this.props.systemParametersData.data.isLocal;
    const currency = isLocal && this.props.campaignObj.local_currency_name ? this.props.campaignObj.local_currency_name : 'USD';
    selectedPrPkg = props?.selectedItems?.length && props?.selectedItems[0];
    // Check if the selected placement is valid & populate the default data else clear the default data.
    if (selectedPrPkg) {
      let { schemaArr, editFormData } = PlacementDetailsTableService.getFormEditData(taxonomyData?.fields, selectedPrPkg);
      for (const index of schemaArr) {
        // Calling the 'populateTaxonomyValues' function to poulate all the matching fields from selected placement
        this.populateTaxonomyValues(index, editFormData[index], DefaultData, taxonomyData?.fields);
        DefaultData['selectedFormDataAbbrevation'][index] = editFormData[index];
      }
      let rateField = isLocal && currency ? 'rate_local' : 'rate';
      let plannedCostield = isLocal && currency ? 'planned_cost_local' : 'planned_cost';
      DefaultData["Rate"] = selectedPrPkg[rateField] ? selectedPrPkg[rateField] : "";
      DefaultData["Unit Amount"] = selectedPrPkg["unit_amount"] ? selectedPrPkg["unit_amount"] : "";
      DefaultData["Planned Cost"] = selectedPrPkg[plannedCostield] ? selectedPrPkg[plannedCostield] : "";
      DefaultData["costMethod"] = selectedPrPkg["cost_method"];
      DefaultData["overrideAdservingFees"] = selectedPrPkg["is_ad_server_fee_override"]
      DefaultData["overrideAdverificationFees"] = selectedPrPkg["is_ad_verification_fee_override"]

      //Assign value to CPC Calculation Type if have , if CPC selected parameter "cost method"
      DefaultData["CPC Calculation Type"] = this.getCpcCalculationType(selectedPrPkg["cost_method"], selectedPrPkg['cpc_calc_type']);
      let parameterEditFormData = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(selectedPrPkg["parameter_code"], selectedPrPkg["parameter_code_taxonomy_schema"], this.state.defaultTaxonomyData?.fields);
      let parameterEditDisplayFormData = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(selectedPrPkg["parameter_code_taxonomy_display"], selectedPrPkg["parameter_code_taxonomy_schema"], this.state.defaultTaxonomyData?.fields);
      let parameterSchema = (selectedPrPkg["parameter_code_taxonomy_schema"] || "").split("|");
      for (const index of parameterSchema) {
        DefaultData["Parameter Code " + index] = parameterEditFormData[index];
        DefaultData['selectedFormDataAbbrevation']["Parameter Code " + index] = parameterEditDisplayFormData[index];
      }
      this.createPlacementName(DefaultData);
      this.fieldIsUpdated = true;
      this.isFormDirty(DefaultData, props);
    }
  }

  /**
   * This function is used to populate the child placement based on the parent package while creation.
   * @param props - The `props` parameter is an object that contains the props.
   * @param DefaultData - The `DefaultData` parameter is an object that contains the default form data.
   * @param taxonomyData - The `taxonomyData` parameter is an object that contains the taxonomy data.
   * @param fieldNamesArr - The `fieldNamesArr` parameter is an array that contains the field names.
  */ 
  populateChildFieldsBasedOnParent = (props, DefaultData, taxonomyData, fieldNamesArr) => {
    if (props?.placementCategory?.title === 'Line Item' || props?.placementCategory?.title === "Creative Placement" || props?.placementCategory?.title === "Fee type" || this.DirectProgrammaticMainTypes.includes(props?.placementCategory?.type)) {
      if (this.state.programmaticPkgForm) {
        this.populatePlacementFieldsWithPackage(props, DefaultData, taxonomyData, fieldNamesArr);
      }
      // Check for Add Another Placement Dialog & data from parent placement, if present, populate the fields
      if (Object.keys(this.addAnotherPlacementParent).length) {
        this.populateAddAnotherPlacementFields(props, DefaultData, taxonomyData);
      }
    }
  }

  /**
   * This function is used to populate the placement fields from the package while creation.
   * @param props - The `props` parameter is an object that contains the props.
   * @param DefaultData - The `DefaultData` parameter is an object that contains the default form data.
   * @param taxonomyData - The `taxonomyData` parameter is an object that contains the taxonomy data.
   * @param fieldNamesArr - The `fieldNamesArr` parameter is an array that contains the field names.
   */ 
  populatePlacementFieldsWithPackage = (props, DefaultData, taxonomyData, fieldNamesArr) => {
    for (let fName in this.state.programmaticPkgForm) {
      if (this.state.programmaticPkgForm[fName] && fieldNamesArr.includes(fName) && !["Placement Name"].includes(fName)) {
        DefaultData[fName] = this.state.programmaticPkgForm[fName];
      } else if (this.state.programmaticPkgForm[fName] && !fieldNamesArr.includes(fName)) {
        // Calling the 'populateTaxonomyValues' function to poulate all the matching fields from parent placement to child
        this.populateTaxonomyValues(fName, this.state.programmaticPkgForm[fName], DefaultData, taxonomyData?.fields);
      }
    }
    //if we creating split budget and created pakge and one line item then if condition will run 
    let ChildItems = this.state.programmaticPackageData && this.state.programmaticPackageData[0]?.childLineItems;
    if (props.placementCategory?.title === 'Line Item' && ChildItems?.length) {
      let rate = this.state.programmaticPackageData[0].placementCost.rate.amount;
      let unitAmunt = Number(this.state.programmaticPackageData[0].placementCost.unitAmount);
      ChildItems.forEach(item => {
        unitAmunt = unitAmunt - Number(item.placementCost.unitAmount);
      });
      DefaultData["Rate"] = rate > 0 ? rate : 0;
      DefaultData["Unit Amount"] = unitAmunt > 0 ? unitAmunt : 0;
    } else {
      DefaultData["Rate"] = this.state.programmaticPkgForm["Rate"];
      DefaultData["Unit Amount"] = this.state.programmaticPkgForm["Unit Amount"];
      DefaultData["Planned Cost"] = this.state.programmaticPkgForm["Planned Cost"];
      DefaultData["costMethod"] = this.state.programmaticPkgForm["costMethod"];
    }
    //Assign value to CPC Calculation Type if have , if CPC selected parameter "cost method"
    DefaultData["CPC Calculation Type"] = this.getCpcCalculationType(this.state.programmaticPkgForm["costMethod"], this.state.programmaticPkgForm['CPC Calculation Type']);
    this.createPlacementName(DefaultData);
    this.isFormDirty(DefaultData, props);
  }

  /**
   * This function is used to populate the add another placement fields from the parent placement while creation.
   * @param props - The `props` parameter is an object that contains the props.
   * @param DefaultData - The `DefaultData` parameter is an object that contains the default form data.
   * @param taxonomyData - The `taxonomyData` parameter is an object that contains the taxonomy data.
   */ 
  populateAddAnotherPlacementFields = (props, DefaultData, taxonomyData) => {
    let placementData = this.addAnotherPlacementParent?.childLineItems?.length ? this.addAnotherPlacementParent.childLineItems[0] : this.addAnotherPlacementParent;
    let placementFormData = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(placementData['placementTaxonomy'], placementData["taxonomySchema"], taxonomyData?.fields);
    let schemaArr = placementData["taxonomySchema"] ? placementData["taxonomySchema"].split("|") : [];
    for (const field of schemaArr) {
      // Calling the 'populateTaxonomyValues' function to poulate all the matching fields from selected placement
      DefaultData[field] = placementFormData[field];
    }

    DefaultData["Rate"] = placementData.placementCost?.rate?.amount;
    DefaultData["Unit Amount"] = placementData.placementCost?.unitAmount;
    DefaultData["Planned Cost"] = placementData.placementCost?.plannedCost?.amount;

    let parameterPlacementFormData = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(placementData["parameterCode"], placementData["parameterCodeTaxonomySchema"], this.state.defaultTaxonomyData?.fields);
    let parameterSchema = (placementData["parameterCodeTaxonomySchema"] || "").split("|");
    for (const field of parameterSchema) {
      DefaultData["Parameter Code " + field] = parameterPlacementFormData[field];
    }
    //Assign value to CPC Calculation Type if have , if CPC selected parameter "cost method"
    DefaultData["CPC Calculation Type"] = this.getCpcCalculationType(DefaultData["costMethod"], placementData['cpc_calc_type']);
    this.createPlacementName(DefaultData);
    this.isFormDirty(DefaultData, props);
  }

  /**
   * This updates the required fields based on the taxonomy data and loads the taxonomy accordion `updaterequiredFields`.
   * @param props The props object before the component updated.
   * @param isOverride boolean value to check for name override and add taxanomy required field based on it only when it is false
   * React that represents the previous state of the component before the update. It is an object that
   * comparing the previous state with the current state adding thr paramter code with fieldName.
   */  
  updaterequiredFields = (props, isOverride) => {
    this.requiredFields = [...this.defaultRequiredFields]
    if(!isOverride){
      for (const field of (this.state.taxonomyData?.fields || [])) {
        if (field.mandatory && !field.hidden && !this.requiredFields.includes(field.name) && ![3, 10].includes(field.field_type)) {
          this.requiredFields.push(field.name);
        }
      }
    }
  }

  handleModalClick = (event) => {
    event.stopPropagation();
  };

  /** The below code is defining a function called "close" in JavaScript. Inside the function, it is
   * using the "setState" method to update the state of the component. It sets the
   * "ProgrammaticPackageData" property to null, "programmaticPkgForm" property to null. 
   * Finally, it calls the "onDialogClose" method that is
   * passed as a prop to the component. 
   */
  close = (success) => {
    this.fieldIsUpdated = false;
    this.setState({ isPlacementModalOpen:false,editPlacementName: false, ProgrammaticPackageData:null,programmaticPkgForm:null, validationFlag: false, emptyFieldError: false });
    this.props.onDialogClose(success);
  };

  /**
   * Retrieves the package type based on the programmatic type.
   * @returns {string} The corresponding package type.
   */
  getPackageType = () => {
    if (this.props.editDailog) {
      if (this.props.placementCategory?.title === "Package" && this.props.placementCategory?.type.includes("Programmatic")) {
        return "ProgrammaticPackage"
      } else if (this.props.placementCategory?.title === "Placement" && this.props.placementCategory?.type.includes("Programmatic")) {
        return "ProgrammaticPlacement"
      } else if (this.props.placementCategory?.title === 'Line Item') {
        return this.props.placementCategory?.type === 'Direct' ? "DirectLine" : "DSP";
      } else if (this.props.placementCategory?.title === 'Creative Placement' && this.props.placementData.package_type !== 'DirectCreative') {
        return "Child"
      } else if (this.props.placementCategory.type === "Search") {
        return "SearchOrder"
      } else if (this.props.placementCategory.type === "Fee") {
        return "FeeOrder"
      } else if (this.props.placementData.package_type === 'DirectCreative' && this.props.placementCategory?.title === 'Creative Placement') {
        return "DirectCreative"
      } else {
        return this.props.placementData.package_type
      }
    } else {
      if (this.props.placementCategory?.type.includes('Direct') && this.props.placementCategory?.title === 'Creative Placement') {
        return "DirectCreative"
      } else if (this.props.placementCategory?.title === "Package" && this.props.placementCategory?.type.includes("Programmatic")) {
        return "ProgrammaticPackage"
      } else if (this.props.placementCategory?.title === "Placement" && this.props.placementCategory?.type.includes("Programmatic")) {
        return "ProgrammaticPlacement"
      } else if (this.props.placementCategory?.title === 'Line Item') {
        return this.props.placementCategory?.type === 'Direct' ? "DirectLine" : "DSP";
      } else if (this.props.placementCategory?.title === 'Creative Placement' || (this.props.placementCategory?.type.includes('Direct') && this.state.programmaticPackageData)) {
        return "Child"
      } else if (this.props.placementCategory.type === "Search") {
        return "SearchOrder"
      } else if (this.props.placementCategory.type === "Fee") {
        return "FeeOrder"
      } else if(this.props.placementCategory?.title.includes('Offline Package')){
        return "OfflinePackage"
      } else if(this.props.placementCategory?.title.includes('Network Package')){
        return "NationalTVNetworkPackage"
      } else if(this.props.placementCategory?.title.includes('Network Estimate Name')){
        return "NationalTVNetworkEstimateName"
      } else if(this.props.placementCategory?.title.includes('Estimate Name')){
        return "OfflineEstimateName"
      } else if(this.props.placementCategory?.title.includes('DOOH Package')){
        return "DoohPackage"
      } else if(this.props.placementCategory?.title.includes('DOOH Placement')){
        return "DoohPlacement"
      }
    }
  }

   /**
  * Handles the creation of a new placement or package.
  * This method:
  * 1. Transforms form data using the specified text case from taxonomy
  * 2. Activates a spinner to indicate loading
  * 3. Creates either a direct programmatic package or a regular placement based on category
  * 4. Posts the created payload to the server
  * 
  * @param {boolean} add_next - Indicates whether an additional action should be performed after creating the placement or package
  * @returns {void} - This function does not return a value directly
  */
  createPlacementOrPackage = (add_next) => {
    trackEvent('Placement create requested', { access_from: 'Placements Dialog', placementCategory: this.props?.placementCategory?.title, type: this.props?.placementCategory?.type, campaignId: this.props?.campaignObj?.id });
    // Transform the form data based on taxonomy text case settings
    let formData = {
      ...this.state.formData,
      taxonomy: this.state?.taxonomySelectedValueJson,
      taxonomy_client_id: this.state?.taxonomyData.clientid,
      taxonomy_schema_id: this.state?.taxonomyData.id
    };
    this.setState({ spinnerCount: 1 });
    if (this.DirectProgrammaticTypes.includes(this.props.placementCategory?.title)) {
      let selectedItems = this.props.placementCategory?.taxonomyType === "DirectPackage" ? this.props.selectedItems : [];
      CreatePlacementOrPackageService.prepareCreatePackagePayload(
        formData,
        this.props.omniProfile,
        selectedItems,
        this.getPackageType(),
        this.state.taxonomyData
      ).then((payload) => {
        if(this.props.placementCategory?.title === 'Package' && this.props.placementCategory?.type.includes('Programmatic')){
          let programmaticPackageData = this.state.programmaticPackageData;
          let childLineItems = [];
          if(programmaticPackageData?.length && programmaticPackageData[0]?.childLineItems?.length){
            childLineItems = CreatePlacementOrPackageService.assignParameterValueToChildPlacement(
              payload[0],
              programmaticPackageData[0]?.childLineItems,
              this.state.defaultTaxonomyData,
              this.state.taxonomyData // Pass taxonomy data for recursive text case transformation
            );
          }
          programmaticPackageData = payload;
          programmaticPackageData[0].childLineItems = childLineItems;
          this.setState({ spinnerCount: 1 });
          this.postPlacementOrPackage(programmaticPackageData,add_next,true);
        }else{
          this.postPlacementOrPackage(payload);
        }
      });
    } else {
      const payload =
        CreatePlacementOrPackageService.prepareCreatePlacementPayload(
          formData,
          this.props.omniProfile,
          this.addAnotherPlacementParent?.id && this.addAnotherPlacementParent?.childLineItems?.length && !this.props.placementCategory?.title.includes('Estimate Name') ? "Child" : this.getPackageType(),
          this.addAnotherPlacementParent?.id && this.addAnotherPlacementParent?.childLineItems?.length ? this.addAnotherPlacementParent.id : this.props.programmaticParentId,
          this.props.selectedItems,
          this.state.taxonomyData
        );
      this.postPlacementOrPackage(payload,add_next);
    }
  };

  /**
   * saveProgrammaticPackage - Saves a programmatic package or line item.
   * Direct Package - Saves a Direct package or Child item
   * @param {boolean} add_next - Indicates whether an additional action should be performed after saving the programmatic package or line item.
   * @returns {void} - This function does not return a value directly. It may execute additional actions based on the provided parameters.
   */
  addAnotherPlacementParent = {};
  saveProgrammaticPackage = (add_next) => {
    trackEvent('Programmatic package save requested', { access_from: 'Placements Dialog', placementCategory: this.props?.placementCategory?.title, type: this.props?.placementCategory?.type, campaignId: this.props?.campaignObj?.id });
    let formData = {
      ...this.state.formData,
      taxonomy: this.state?.taxonomySelectedValueJson,
      taxonomy_client_id: this.state?.taxonomyData.clientid,
      taxonomy_schema_id: this.state?.taxonomyData.id
     };
    if (this.DirectProgrammaticTypes.includes(this.props.placementCategory?.title)) {
      this.setState({programmaticPkgForm : formData});
      CreatePlacementOrPackageService.prepareCreatePackagePayload(
        formData,
        this.props.omniProfile,
        [],
        this.getPackageType(),
        this.state.taxonomyData
      ).then((payload) => {
        if(this.props.placementCategory?.title === 'Package' && this.props.placementCategory?.type.includes('Programmatic')){
          let programmaticPackageData = this.state.programmaticPackageData;
          let childLineItems = [];
          if(programmaticPackageData?.length && programmaticPackageData[0]?.childLineItems?.length){
            childLineItems = CreatePlacementOrPackageService.assignParameterValueToChildPlacement(
              payload[0],
              programmaticPackageData[0]?.childLineItems,
              this.state.defaultTaxonomyData,
              this.state.taxonomyData // Pass taxonomy data for recursive text case transformation
            );
          }
          programmaticPackageData = payload;
          programmaticPackageData[0].childLineItems = childLineItems;
          this.setState({ spinnerCount: 1 });
          this.postPlacementOrPackage(programmaticPackageData,add_next,true);
        }
        // For Direct Package, open next create dialog box to create child item
        if(["DirectPackage","SocialPackage","OfflinePackage"].includes(this.props.placementCategory?.taxonomyType) && this.DirectProgrammaticMainTypes.includes(this.props.placementCategory?.type)){
          this.setState({isPlacementModalOpen:false,  editPlacementName: false, formData: {placementName:''}, programmaticPackageData: payload});
          this.props.CallLineItemProgramatically(payload,this.props?.placementCategory?.title, this.props?.placementCategory?.type);
        }
      });
    }
    else if (this.props.placementCategory?.title === 'Line Item' || this.DirectProgrammaticMainTypes.includes(this.props.placementCategory?.type)) {
      CreatePlacementOrPackageService.prepareCreatePackagePayload(
        formData,
        this.props.omniProfile,
        [],
        this.getPackageType(),
        this.state.taxonomyData
      ).then((payload) => {
        const programmaticPackageData = this.state.programmaticPackageData;
        programmaticPackageData[0].childLineItems.push(payload[0]);
        this.addAnotherPlacementParent = programmaticPackageData[0];
        this.setState({programmaticPackageData:programmaticPackageData, spinnerCount: 1});
        this.postPlacementOrPackage(programmaticPackageData,add_next);
      });
    }
  }

  /**
 * Callback function to handle the response after a placement creation attempt.
 * @param {Object} response - The response object received from the server.
 * @param {Object} payload - The payload object used for the placement creation request.
 * @param {function} add_next - A function to be called after successful placement creation.
 * @param {boolean} from_prgm_pkg - A flag indicating if the placement is from a programmatic package.
 * @param {string} type - The type of placement being created.
 * @returns {void} - This function does not return anything.
 */
  postPlacementSuccessCallback = (response, payload,add_next,from_prgm_pkg, type) => {
    if (response?.data?.result[0]?.status === "success") {
      this.setState({ spinnerCount: 0 });
      this.close(true);
      let message = '';
      if(type){
        message = `${type} is created successfully`;
      } else if(payload[0]?.childLineItems?.length ){
        
        if(payload[0]?.packageType != "ProgrammaticPackage"){
          message = `Package and ${this.getHeaderName()} are created`
        }else if(payload[0]?.packageType === "ProgrammaticPackage"){
          message = `Programmatic Package and ${this.getHeaderName(payload)} are created`;
        } 
      }else {
        message = `${this.getHeaderName()} is created`;
      }
      AlertMessagesService.showSuccessToastMessage(message);
      trackEvent('Placement create success', { access_from: 'Placements Dialog', message, placementCategory: this.props?.placementCategory?.title, type: this.props?.placementCategory?.type, campaignId: this.props?.campaignObj?.id });
      if (this.props.onPlacementCreate) {
        if(add_next && !Object.keys(this.addAnotherPlacementParent).length)
          this.addAnotherPlacementParent = payload[0];
        else if(add_next && !this.addAnotherPlacementParent.id)
          this.addAnotherPlacementParent = {...this.addAnotherPlacementParent, id: response?.data?.result[0]?.id};
        else if(!add_next)
          this.addAnotherPlacementParent = {};  
        this.props.onPlacementCreate(add_next,from_prgm_pkg ? "Programmatic Package" : this.getHeaderName());
      }
    } else {
      this.setState({ spinnerCount: 0 });
      // Initialize an empty string for the error message
      let errorModalMsg = '';
      // Check if the 'type' variable is truthy and set the error message to its value
      if(type){
        errorModalMsg = type;
        // Check if the first item in the payload is not a ProgrammaticPackage and has childLineItems
      } else if(payload[0]?.packageType != "ProgrammaticPackage" && payload[0]?.childLineItems){
          // Set the error message to include the package type and header name
        errorModalMsg = `Package and ${this.getHeaderName(payload)}`;
      } else if(payload[0]?.packageType === "ProgrammaticPackage" && payload[0]?.childLineItems){
        errorModalMsg = `Programmatic Package and ${this.getHeaderName(payload)}`;
      } else {
        errorModalMsg = this.getHeaderName();
      }
    AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.postPlacementSuccessCallback(response, payload, add_next, from_prgm_pkg, type), title: `Unable to create ${errorModalMsg}`, bodyMsgArr: []}]);
    trackEvent('Placement create failed', { access_from: 'Placements Dialog', error: response, placementCategory: this.props?.placementCategory?.title, type: this.props?.placementCategory?.type, campaignId: this.props?.campaignObj?.id });
    }
  }

  /**
   * Description The below code is defining a function called `postPlacementErrorCallback` which takes two
   * parameters: `error` and `payload`. Inside the function, it sets the `spinnerCount` state to 0 and
   * shows an error toast message using `AlertMessagesService`.
   * @param {object} error
   * @param {object} payload
   * @param {string} id
   * @returns {void}
   */
 postPlacementErrorCallback = (error, payload, id, multiAlertCallBack) => {
    this.setState({ spinnerCount: 0 });
    // Creating message based on the id, If ID is there means it is an update call or else it is a create call
    let message = '';
    if(id){
      message = `${this.getHeaderName()} is not updated`;
    } else {
      if(payload[0]?.packageType != "ProgrammaticPackage" && payload[0]?.childLineItems){
        message = `Package and ${this.getHeaderName(payload)} are not created`;
      }else if(payload[0]?.packageType === "ProgrammaticPackage" && payload[0]?.childLineItems){
        message = `Programmatic Package and ${this.getHeaderName(payload)} are not created`;
      }
       else {
        message = `${this.getHeaderName()} is not created`;
      }
    }
    let errorModalMsg = '';

    if(id){
        // If an ID is present, it indicates an update operation. Set the error message accordingly.
      errorModalMsg = `update ${this.getHeaderName()}`;
      // Check if the first item in the payload is not a ProgrammaticPackage and has childLineItems
    } else if(payload[0]?.packageType != "ProgrammaticPackage" && payload[0]?.childLineItems){
        // If conditions are met, it's a creation operation for a package. Set the error message to reflect creating a package and include the header name.
      errorModalMsg = `create Package and ${this.getHeaderName(payload)}`;
    } else if(payload[0]?.packageType === "ProgrammaticPackage" && payload[0]?.childLineItems){
      errorModalMsg = `create Programmatic Package and ${this.getHeaderName(payload)}`;
    } else {
      errorModalMsg = `create ${this.getHeaderName()}`;
    }
    AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: multiAlertCallBack, title: `Unable to create ${errorModalMsg}`, bodyMsgArr: []}]);
    trackEvent('Placement create error', { access_from: 'Placements Dialog', error, placementCategory: this.props?.placementCategory?.title, type: this.props?.placementCategory?.type, campaignId: this.props?.campaignObj?.id });
  }

  /**
   * Function to handle the update or creation of a placement or package.
   * @param {Object|Array} payload - The payload object or array used for the placement or package creation/update request.
   * @param {function} add_next - A function to be called after successful placement creation.
   * @param {boolean} from_prgm_pkg - A flag indicating if the placement or package is from a programmatic package.
   * @param {string} type - The type of the placement or package.
   * @returns {void} - This function does not return anything.
   */
  postPlacementOrPackage = (payload,add_next,from_prgm_pkg, type) => {
    // Set the isApproved field to true if approval is not required
    if(!this.props?.systemParametersData?.data?.isApprovalRequired){
      payload[0]["isApproved"] = true;
      payload[0].childLineItems?.forEach((item) => {
        item["isApproved"] = true;
      });
    }
    
    if (this.props.editDailog === true && (!this.props.placementData.data_source.includes('planit'))) {
      let campaignId = encodeURIComponent(this.props.campaignObj.id);
      //placement or package update operation
      payload[0]["client_id"] =  this.props.placementData.client_id
      payload[0]['is_currency_local'] = this.props.systemParametersData.data.isCurrencyLocal;
      payload[0]['campaign_netmedia'] = this.props.campaignObj?.campaign_total_budget;
      payload[0]['campaign_netmedia_local'] = this.props.campaignObj?.campaign_total_budget_local;

      CreatePlacementOrPackageService.updatePlacementOrPackage(campaignId,this.props.placementData.id,payload[0],this.props?.versionOneApi).then((response) => {
          if(response?.data?.status === "success"){
            this.setState({ spinnerCount: 0});
            this.close(true);
            if(this.moErrorFields.isMoEdit){
              AlertMessagesService.showSuccessToastMessage("1 error handled successfully");
            } else {
              AlertMessagesService.showSuccessToastMessage(`${this.getHeaderName()} is updated`);
            }
            if (this.props.onPlacementCreate) {
              if(this.moErrorFields.isMoEdit){
                this.props.onPlacementCreate(false, null, true);
              } else {
                this.props.onPlacementCreate();
              }
            }
          } else {
            this.setState({ spinnerCount: 0 });
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.postPlacementOrPackage(payload, add_next, from_prgm_pkg, type), title: `Unable to update ${this.getHeaderName()}`, bodyMsgArr: []}]);
          }
        },
        (error) => {
         this.postPlacementErrorCallback(error, payload, this.props.placementData.id, ()=>this.postPlacementOrPackage(payload, add_next, from_prgm_pkg, type));
        }
      );
    }
    // placement or package create operation
    else {
      // If the creation type is child and the selected item is from PlanIt, create a parent package and attach the child item to it
      if(payload[0].parentId && this.props.selectedItems.length && this.props.selectedItems[0].data_source.includes('planit')){
        let planitData = CreatePlacementOrPackageService.createFormDataForPlanItPackage(this.props.selectedItems[0],payload[0]);
        let parentPayload = CreatePlacementOrPackageService.prepareCreatePlacementPayload(planitData, this.props.omniProfile, planitData.packageType,null,[], taxonomySelectedValueJson);
        parentPayload[0].childLineItems = payload;
        payload = parentPayload;
      }
      // if v2 verion api is selected then attach supplier tier to placement or package while creating
      if (this.props?.versionOneApi === "V2") {
        payload.forEach((item, index) => {
          const selectedPubliser = PlacementDetailsTableService.getSelectedTier(this.props?.campaignObj, item?.placementType, item?.supplier);
          PlacementDetailsTableService.updateParentTier(item, "supplier", selectedPubliser?.tier_id);

          if (item?.childLineItems?.length) {
            item?.childLineItems.forEach((childItem) => {
              const selectedPubliser = PlacementDetailsTableService.getSelectedTier(this.props?.campaignObj, childItem?.placementType, childItem?.supplier);
              PlacementDetailsTableService.updateParentTier(childItem, "supplier", selectedPubliser?.tier_id);

              if (childItem?.childLineItems?.length) {
                childItem?.childLineItems.forEach((subChildItem) => {
                  const selectedPubliser = PlacementDetailsTableService.getSelectedTier(this.props?.campaignObj, subChildItem?.placementType, subChildItem?.supplier);
                  PlacementDetailsTableService.updateParentTier(subChildItem, "supplier", selectedPubliser?.tier_id);
                })
              }
            })
          }
        })
      }

      let campaignId = encodeURIComponent(this.props.campaignObj.id);
      payload[0]['is_currency_local'] = this.props.systemParametersData.data.isCurrencyLocal;
      payload[0]['campaign_netmedia'] = this.props.campaignObj?.campaign_total_budget;
      payload[0]['campaign_netmedia_local'] = this.props.campaignObj?.campaign_total_budget_local;
      CreatePlacementOrPackageService.createPlacementOrPackage(campaignId, payload, this.props?.versionOneApi ).then(
        (response) => {
          this.setState({programmaticPackageData:null,programmaticPkgForm:null})
          this.postPlacementSuccessCallback(response, payload,add_next,from_prgm_pkg, type)
        },
        (error) => {
          if(this.props.placementCategory?.title === 'Line Item' || this.props.placementCategory?.type.includes('Direct')){
            this.setState({programmaticPackageData:null,programmaticPkgForm:null})
          }
         this.postPlacementErrorCallback(error, payload, undefined, ()=>this.postPlacementOrPackage(payload, add_next, from_prgm_pkg, type))
        }
      );
    }
  };

   /**
   * Handles cascading changes for supplier data.
   * This function first creates a copy of the default taxonomy data from props.
   * It then finds the supplier code data from the taxonomy data fields.
   * It filters the field items of the supplier code data based on the supplier code of the selected object.
   * It updates the fields of the taxonomy data, replacing the field items of the supplier code field with the filtered options.
   * It then sets the 'Parameter Code Supplier Code' and 'Parameter Code Site' fields of the form data to undefined and empty string respectively.
   * It checks if the form is dirty and creates a placement name.
   * Finally, it updates the state with the updated taxonomy data and form data.
   * @param {Object[]} selectedValue - The selected value, each containing a supplier code.
   * @param {Object} formData - The form data to update.
   */
   supplierCascading = (selectedValue, formData) => {
    let defaultTaxonomyDataCopy =  {...this.origDefaultTaxonomyData};
    let supplierCodeData = defaultTaxonomyDataCopy?.fields?.find((field) => [field.name, field.alias].includes('Supplier Code'));
    let filterOptions = supplierCodeData?.fielditems;
    // keeping old code for future references
    // if(supplierCodeData?.fielditems.some((item) => item.code === selectedValue[0].id)){
    //   filterOptions = supplierCodeData?.fielditems.filter((item) => item.code === selectedValue[0].id);
    // }else {
    //   let vendorMappingsData = Object.values(this.props?.vendorMappingsData);
    //   vendorMappingsData?.forEach((vendorItem)=>{
    //     if(vendorItem.planIt.replace(/\s/g, '') === selectedValue[0].value.replace(/\s/g, '')){
    //       filterOptions = supplierCodeData?.fielditems.filter((item) => item.name.substring(item.name.indexOf(' ')+1)?.toLowerCase() === vendorItem.mediaOcean?.toLowerCase());
    //     } else {
    //       filterOptions = supplierCodeData?.fielditems.filter((item) => item.name?.toLowerCase().includes(selectedValue[0].value?.toLowerCase()));
    //     }
    //   })
    // }
    let vendorMappingsData = this.props?.vendorMappingsData;
    if (vendorMappingsData[selectedValue[0]?.value]) {
      filterOptions = vendorMappingsData[selectedValue[0]?.value];
    } else if(vendorMappingsData["sourceSystem"] && !vendorMappingsData[selectedValue[0]?.value]) {
      filterOptions = [{code: "No ordering vendors available", name: "No ordering vendors available"}];
    } else {
      let filterValues = supplierCodeData?.fielditems.filter((item) => item.name?.toLowerCase().includes(selectedValue[0]?.value?.toLowerCase()));
      if (filterValues.length > 0) {
        filterOptions = filterValues;
      }
    }
    const updatedFields = (defaultTaxonomyDataCopy && defaultTaxonomyDataCopy?.fields) && defaultTaxonomyDataCopy?.fields.map((obj) => {
      if (selectedValue[0]?.value && [obj.name, obj.alias].includes('Supplier Code')) {
        return {...obj, fielditems: filterOptions};
      }
      return obj;
    })
    if(formData['Parameter Code Supplier'] !== this.state.formData['Parameter Code Supplier']){
      formData['supplier'] = selectedValue[0]?.value;
      formData['Parameter Code Supplier Code'] = undefined;
      formData['Parameter Code Site'] = '';
    }
    this.isFormDirty(formData);
    this.createPlacementName(formData);
    this.setState( prevState => ({
      defaultTaxonomyData:{...prevState.defaultTaxonomyData, fields: updatedFields},
      formData,
    }));
  };

  /** 
   * The below function handles the cascading changes for the placement fields.
   * It reset the dependent fields dropdowns to their child values if the selected object is present in the cascading map.
   * @param {Object[]} selectedObj - The selected object array.
   * @param {Object} formData - The form data object.
   * @param {boolean} isOnLoad - A boolean value indicating if the function is called on load.
   * @returns {void} - This function does not return anything.
   */
  placementFieldsCascading = (selectedObj,formData, isOnLoad = false) => {
    let taxonomyDataCopy = {};
    let defaultTaxonomyDataCopy = {};
    if(isOnLoad){
      taxonomyDataCopy = this.cascadingMap['updatedTaxonomyData'] ? {...this.cascadingMap['updatedTaxonomyData']} : { ...this.state.taxonomyData };
      defaultTaxonomyDataCopy = this.cascadingMap['updatedDefaultTaxonomyData'] ? {...this.cascadingMap['updatedDefaultTaxonomyData']} : { ...this.state.defaultTaxonomyData };
    } else {
      taxonomyDataCopy = this.state.taxonomyData ? { ...this.state.taxonomyData } : {}; 
      defaultTaxonomyDataCopy = this.state.defaultTaxonomyData ? { ...this.state.defaultTaxonomyData } : {}; 
    }

    let dependentFields = []; //variable to store dependent field names
    let updatedTaxonomyDataFields = this.updateTaxonomyFields(taxonomyDataCopy, selectedObj, dependentFields);
    let updatedDefaultTaxonomyDataFields = this.updateDefaultTaxonomyFields(defaultTaxonomyDataCopy, selectedObj, dependentFields);
   
    // update the field value to undefined
    if(dependentFields.length) {
      // If the selected object has a field_id, add the dependent fields to the cascading map.
      dependentFields.forEach((field) => {
        if(!isOnLoad){
          formData[field] = undefined;
        }
      });
    } else {
      // If the selected object is present in the cascading map, reset the dependent fields dropdowns.
      if(selectedObj && this.cascadingMap[Number(selectedObj[0]?.field_id)]){
        //if updatedTaxonomyDataFields is undefiend will not run loop
        if(updatedTaxonomyDataFields?.length){
          updatedTaxonomyDataFields = updatedTaxonomyDataFields.map((obj, index) => {          
            // For no explicit mapping, reset the dependent fields to original values else if explicit mapping, reset the fielditems to empty array
            if(this.cascadingMap[Number(selectedObj[0].field_id)].includes(Number(obj.id))){
              obj = {...this.origTaxonomyData.fields[index]};
              if(obj.isExplicitCascading){
                obj.fielditems = [];
                obj.parentFieldName = selectedObj[0].fieldName;
                obj.showExplicitInfo = true;
              }
              return obj;
            } else return obj;
          });
        }
        //if updatedDefaultTaxonomyDataFields is undefiend will not run loop
        if(updatedDefaultTaxonomyDataFields?.length){
          updatedDefaultTaxonomyDataFields = updatedDefaultTaxonomyDataFields.map((obj, index) => {
            if(this.cascadingMap[Number(selectedObj[0].field_id)].includes(Number(obj.id))){
              obj = {...this.origDefaultTaxonomyData.fields[index]};
              if(obj.isExplicitCascading){
                obj.fielditems = [];
                obj.parentFieldName = selectedObj[0].fieldName;
                obj.showExplicitInfo = true;
              }
              return obj;
            } else return obj;
          });
        }
      }
    }
    //update cascading map with updated fields
    this.cascadingMap['updatedTaxonomyData'] = {fields : updatedTaxonomyDataFields};
    this.cascadingMap['updatedDefaultTaxonomyData'] = {fields: updatedDefaultTaxonomyDataFields}

    //update state
    this.isFormDirty(formData);
    this.createPlacementName(formData, isOnLoad);
    this.setState(prevState => ({
      taxonomyData: {...prevState.taxonomyData, fields: updatedTaxonomyDataFields},
      defaultTaxonomyData:{...prevState.defaultTaxonomyData, fields: updatedDefaultTaxonomyDataFields},
      formData
    }));
  }

  /** The below code is updating the taxonomyFields array by mapping over the
    * `fields` array of `defaultTaxonomyDataCopy`. For each object in the `fields` array, it checks if
    * there is a matching `FieldId` in the `childitems` array of the first object in the `selectedObj`
    * array. If there is a match, it creates a new object with properties `field_id`, `name`, `code`,
    * and `id` from the matching child item, and pushes it to the `updatedFieldItems` array.
    * If the `updatedFieldItems` array has items, it pushes the updated object to the `dependentFields`
    * array and returns the updated object. If there are no items in the `updatedFieldItems` array, it
    * returns the original object.
    * @param {Object} taxonomyDataCopy - The taxonomy data copy object.
    * @param {Object[]} selectedObj - The selected object array.
    * @param {string[]} dependentFields - The dependent fields array.
    * @returns {Object[]} - The updated taxonomy fields array. 
  */
  updateTaxonomyFields = (taxonomyDataCopy, selectedObj, dependentFields) => {
    return taxonomyDataCopy && taxonomyDataCopy?.fields && taxonomyDataCopy.fields.map((obj, index) => {
      let updatedFieldItems = [];
      if(selectedObj?.length && Number(selectedObj[0]?.field_id) === Number(obj.id)) {
        selectedObj[0].fieldName = obj.alias || obj.name;
      }
      selectedObj && selectedObj[0]?.childitems?.forEach((child) => {
        if (Number(obj.id) === Number(child.FieldId)) {
          const childObj = this.origTaxonomyData?.fields[index]?.fielditems?.find((item) => Number(item.id) === Number(child.Id));
          updatedFieldItems.push(childObj);
        }
      });
      if (updatedFieldItems.length > 0) {
        dependentFields.push(obj.name);
        obj.showExplicitInfo = false;
        return { ...obj, fielditems: updatedFieldItems };
      } else {
        return { ...obj };
      }
    });
  }

  /** The below code is updating the defaultTaxonomyFields array by mapping over the
    * `fields` array of `defaultTaxonomyDataCopy`. For each object in the `fields` array, it checks if
    * there is a matching `FieldId` in the `childitems` array of the first object in the `selectedObj`
    * array. If there is a match, it creates a new object with properties `field_id`, `name`, `code`,
    * and `id` from the matching child item, and pushes it to the `updatedFieldItems` array.
    * If the `updatedFieldItems` array has items, it pushes the updated object to the `dependentFields`
    * array and returns the updated object. If there are no items in the `updatedFieldItems` array, it
    * returns the original object.
    * @param {Object} defaultTaxonomyDataCopy - The default taxonomy data copy object.
    * @param {Object[]} selectedObj - The selected object array.
    * @param {string[]} dependentFields - The dependent fields array.
    * @returns {Object[]} - The updated default taxonomy fields array. 
  */
  updateDefaultTaxonomyFields = (defaultTaxonomyDataCopy, selectedObj, dependentFields) => {
    return defaultTaxonomyDataCopy && defaultTaxonomyDataCopy?.fields.map((obj, index) => {
      let updatedFieldItems = [];
      if(selectedObj?.length && Number(selectedObj[0]?.field_id) === Number(obj.id)) {
        selectedObj[0].fieldName = obj.alias || obj.name;
      }
      selectedObj && selectedObj[0]?.childitems?.forEach((child) => {
        if (Number(obj.id) === Number(child.FieldId)) {
          const childObj = this.origDefaultTaxonomyData?.fields[index]?.fielditems?.find((item) => Number(item.id) === Number(child.Id));
          updatedFieldItems.push(childObj);
        }
      });
      if (updatedFieldItems.length > 0) {
        dependentFields.push("Parameter Code " + obj.name);
        obj.showExplicitInfo = false;
        return { ...obj, fielditems: updatedFieldItems };
      } else {
        return { ...obj };
      }
    });
  }
 
/**
 * Handles the data change event and marks field as touched.
 */
  onDataChange = (type, event, fieldObject = null, isFeeCalc = false, caretPostionObj = {}, nativeEvent={}) => {
    // Mark field as touched when user interacts with it
    const touchedFields = { ...this.state.touchedFields };
    touchedFields[type] = true;

    if(isFeeCalc)
      this.feeCalcParam = type;
    //fetch value from event
    const value = Utils.getValue(event);
    let formData = { ...this.state.formData };
    let errorForm = {...this.state.errorForm};
    formData[type] = value;

    if(type === "Placement Name" && (this.state.editPlacementName || this.props.editDailog && this.props.placementData?.override_taxonomy)){
      formData['Override Placement Name'] = value;
    }

    formData['selectedFormDataAbbrevation'][type] = event?.target?.selected?.[0]?.label || event?.target?.value?.[0]?.value;
    if (type === "Flight Start" || type === "Flight End") {
      formData[type] = Utils.formatDateObject(value);
      let el = document.getElementById(type);
      el.setAttribute("data-date", formData[type]);
    } else {
      formData[type] = value;
      if(type === 'Parameter Code Cost Method'){
        formData = this.onChangeCostValue(formData,value)
      }
    }
    if(type === 'Parameter Code Buy Type'){
      let adOptions = this.setAdOptions(formData['selectedFormDataAbbrevation'][type]);

      formData['Parameter Code Ad Server'] = adOptions?adOptions?.adServingMatchedValue?.value:'';
      formData['Parameter Code Ad Verification'] = adOptions?adOptions?.adVerificationMatchedValue?.value:'';
    }
    
    if(event?.target?.getAttribute && event?.target?.getAttribute("fieldid")){
      let fieldId = event.target.getAttribute("fieldid");
      let cascadeType = event.target.getAttribute("fieldtype") === "parameter_code" ? "taxonomy" : "parameter_code";
      event.target.closest("div.message-body").querySelectorAll(`[fieldtype="${cascadeType}"][fieldid="${fieldId}"]`).forEach(cascadeDom =>
        {
          formData[cascadeDom.getAttribute("fieldname")] = value;
        });
    }
    if(type === 'Parameter Code Supplier Code'){
      const selectValue = (Array.isArray(event.target.value) && typeof event.target.value[0] === 'object') ? event.target.value[0] : event.target.value;
      if(selectValue.value !== 'No ordering vendors available'){
        //on updating 'Parameter Code Supplier Code', function stuck in loop so used extra value 'supplierCode' to save supplier
        formData['supplierCode'] = selectValue.id;
        formData[type] = selectValue.id

        //on selecting value of supplier code below code will split value into code and name,
        //then name string will aigin to site.
        const string = selectValue.value;
        const indexOfSpace = string.indexOf(" ");
        const restOfString = string.slice(indexOfSpace + 1);
        if(string !== restOfString){
          formData['Parameter Code Site'] = restOfString
        }
      }
    }

    if(type === 'Unit Amount'){
      if(formData["Unit Amount"] && formData["Unit Amount"]?.toString().indexOf(".") > -1){
        errorForm["Unit Amount"] = true;
      } else {
        errorForm["Unit Amount"] = false;
      }
    }

    // if cost method is flat and cost is updated, assign cost value to rate field
    if(type === 'Planned Cost' && formData['costMethod'] === 'Flat'){
      formData['Rate'] = value;
    }

    //condition check to implement cascading for placement taxonomy(required)
    if (fieldObject) {
      //retrive selected dropdown item
      const selectedObj = fieldObject?.fielditems?.length > 0
          ? fieldObject.fielditems.filter((x) => x?.code?.trim() === value?.trim()) : null;
      
      if(type === 'Parameter Code Supplier'){
        this.supplierCascading(event.target.value,formData)
      } else {
        this.placementFieldsCascading(selectedObj, formData)
      }
        this.setState({ errorForm });
    }  
    else {
      this.isFormDirty(formData);
      this.createPlacementName(formData);
      this.setState({ formData: formData, errorForm, touchedFields }, ()=>{        
        nativeEvent?.target?.setSelectionRange(caretPostionObj?.caretStart, caretPostionObj?.caretEnd);  
      });
    }
    this.fieldIsUpdated = true; 
  };

  /**
   * On Changing cost value, assign other fields value based on cost method
   * @param {Object} formData 
   * @param {string} value 
   * @returns return object 
   */
  onChangeCostValue(formData,value){
    formData['costMethod'] = value;
    // Assign value to CPC Calculation Type if have , if CPC selected parameter "cost method"
    formData["CPC Calculation Type"] = this.getCpcCalculationType(value,formData["CPC Calculation Type"]);
    // If cost method is Flat, assign rate to zero
    if(formData['costMethod'] === "Flat"){
      formData["Rate"] = 0;
    // If cost method is Free, assign rate & cost to zero  
    } else if(formData['costMethod'] === "Free"){
      formData["Rate"] = 0;
      formData["Planned Cost"] = 0;
    }
    return formData
  }
  /**
   * Camparing both array to get first common value. 
   * @param {Array} schemaOption 
   * @param {Array} campaignsChannelAdOptions 
   * @returns Object get value After comparening both Array
   */
  getValueAfterCompareTwoArray(schemaOption,campaignsChannelAdOptions){
    let firstMatchObject = null;
    campaignsChannelAdOptions.map((firstObj, i) => {
      if(schemaOption && schemaOption.length){
        schemaOption.map((compareObj) => {
          if (firstObj.label === compareObj.name && firstMatchObject === null) {
            firstMatchObject = {name:compareObj.name,value: compareObj.code};
          }
        })
      }
    });
    return firstMatchObject
  }
  getDateRange = () => {
    const startDate = this.state.formData["Flight Start"];
    const endDate = this.state.formData["Flight End"];
    if (startDate && endDate) {
      const range = Utils.formatDateObject(startDate) + " - " + Utils.formatDateObject(endDate);
      return range ;
    }
    else{
      return "Mon DD, YYYY - Mon DD, YYYY";
    }
  };

  /** The below code is a JavaScript function called `isFormDirty`
  * @param {formatData} object 
  * @param  {updatedProps} object  
   * "Placement Name" field is only whitespace. If any of these conditions are met, the function sets a
   * boolean variable `isSaveDisabled` to `true`. If none of these conditions are met, the function
   * sets `isSaveDisabled` to `false`. The function does not return anything, but instead modifies the
   * value of `isSaveDisabled` which is likely used elsewhere in the code 
  */
  isFormDirty = (formData, updatedProps) => {
    for (const field of this.requiredFields) {
      if (!formData[field] || this.state.errorForm[field]) {
        this.isSaveDisabled = true;
        return;
      }
    }

    if(formData["Placement Name"].trim() === "" || this.state.errorForm["Placement Name"]){
      this.isSaveDisabled = true;
      return;
    }
    if(formData["Parameter Code Cost Method"] === "CPC" && (!formData["CPC Calculation Type"] || formData["CPC Calculation Type"] === "")){
      this.isSaveDisabled = true;
      return;
    }

    if(formData["Unit Amount"]?.toString().indexOf(".") > -1){
      this.isSaveDisabled = true;
      return;
    }
    // Check for any field-specific errors that might have been set by textFieldValidator (including space errors)
    for (const key in this.state.errorForm) {
        if (this.state.errorForm[key] === true) {
            this.isSaveDisabled = true;
            return;
        }
    }

    if(this.props.placementCategory?.title === 'Package' && this.props.placementCategory?.type.includes("Programmatic")){
      if(this.state.programmaticPackageData?.length && this.state.programmaticPackageData[0]?.childLineItems.length){
        this.isSaveDisabled = false;
        this.fieldIsUpdated = true;
      }else {
        this.isSaveDisabled = true;
      }
    }else{
      this.isSaveDisabled = false;
      this.fieldIsUpdated = true;
    }
  };
  
  /** 
   * The below code is a JavaScript function called `createPlacementName`. It takes in a `formData`
   * object as a parameter. The function is used to create a placement name and display name based on
   * the values provided in the `formData` object and  will create the name without hidden fields from 
   * taxonomy and create the name if there is no hidden fields from taxonomy
   */
  createPlacementName = (formData, isOnLoad = false) => {
    let isOverride = this.state.editPlacementName;
    let filedsHidden =  this.updatedTaxonomyData?.fields.filter(field=> field.hidden == true)?.length;
    if(!this.state.taxonomyData){
      isOverride = true;
    }
    formData["isOverride"] = isOverride;

    let {taxonomySelectedValueJson} = PlacementUtils.createNames(formData,this.updatedTaxonomyData);

    formData["Placement Schema"] = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'field_name',false,this.updatedTaxonomyData?.fields);
    if(isOverride){
      formData["Override Placement Name"]  = formData['Override Placement Name'] ; 
      formData["Override Placement Display Name"] = null;
      formData["Placement Display Name"]  = null;
    }else{
      if(filedsHidden){
        if (!isOnLoad) {
          formData["Placement Name"] = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',false,this.updatedTaxonomyData?.fields);
        }
        formData["Placement Display Name"] = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',false,this.updatedTaxonomyData?.fields);

        formData["Override Placement Name"] =  PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',true,this.updatedTaxonomyData?.fields);
        formData["Override Placement Display Name"]  = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',true,this.updatedTaxonomyData?.fields);
      }else{
        if (!isOnLoad) {
          formData["Placement Name"] =  PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',true,this.updatedTaxonomyData?.fields);
        }
        formData["Placement Display Name"] =  PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',true,this.updatedTaxonomyData?.fields);
        formData["Override Placement Name"] = null;
        formData["Override Placement Display Name"]  = null;
      }
    }

    // just delete field_name, name from taxonomySelectedValueJson before saving in state
    taxonomySelectedValueJson = taxonomySelectedValueJson.map((item) => {
      delete item['field_name'];
      delete item['name'];
      delete item['hidden'];
      return item;
    });

    this.setState({ formData: formData, taxonomySelectedValueJson: taxonomySelectedValueJson }, () => {
      // Adding a check on placement name character limit on each change
      setTimeout(() => {
        let errorFormData = { ...this.state.errorForm };
        if (formData["Placement Name"].trim().length > this.placementMaxCharLimit) {
          errorFormData["Placement Name"] = "charlimitexceeds";
          this.isSaveDisabled = true;
          this.setState({ errorForm: errorFormData });
        } else {
          errorFormData["Placement Name"] = false;
          this.isSaveDisabled = this.isSaveDisabled ? true : false;
          this.setState({ errorForm: errorFormData });
        }
      });
    });
    
    if(!this.state.taxonomyData){
      formData["Placement Display Name"] = formData["Placement Name"];
      formData["Placement Schema"] = null;
      formData["Override Placement Name"] = null;
      formData["Override Placement Display Name"]  = null;
    }
    this.setParameterCode(formData);
  };

  /** 
   * The below code is a JavaScript function called `setParameterCode` that takes in a `formData` 
   * takes in a formData object as a parameter. It checksif a certain condition is met and if so, 
   * it clears out some fields in the formData object. Sets the parameter code values based on the provided form data.
   * It theniterates through the fields of a defaultTaxonomyData object and checks if the corresponding field
   * value exists in the formData object and is not hidden. If so, it adds the field name to a
   * parameterCodeSchemaArr array and the field value and display name to parameterCodeArr and
   * parameterCodeDisplayNameArr arrays respectively. Finally, it joins the arrays with a delimiter
   * value specified in the defaultTaxonomy 
   */
  setParameterCode = (formData, saveFlag =  false ) => {
    if (this.isSaveDisabled) {
      formData["Parameter Code"] = "";
      formData["Parameter Code Display Name"] = "";
      formData["Parameter Code Schema"] = "";
      this.setState({ formData: formData });
    }
    let parameterCodeArr = [];
    let parameterCodeDisplayNameArr = [];
    let parameterCodeSchemaArr = [];
    this.state.defaultTaxonomyData?.fields.forEach((field, index) => {
      let fieldValue = formData["Parameter Code "+field.name];
      //supplier code is in array 
      if('Parameter Code Supplier Code' === "Parameter Code "+field.name){
        fieldValue = formData['Parameter Code Supplier Code'];
      }
      if(fieldValue && !field.hidden){
        parameterCodeSchemaArr.push(field.name);
        if (field && field.fielditems && field.fielditems.length) {
          let optionFieldValue = Array.isArray(fieldValue) && fieldValue[0]?.value ? fieldValue[0]?.value : fieldValue;
          let flag = false;
          field.fielditems.forEach((option) => {
            // Case-insensitive comparison to handle state values in different cases
            if (option.code && optionFieldValue && 
                option.code?.toLowerCase() === optionFieldValue?.toLowerCase() && !flag) {
              parameterCodeArr.push(option.code);
              parameterCodeDisplayNameArr.push(option.name);
              flag = true;
            }
          });
          if(!flag){
            if( Array.isArray(fieldValue) && fieldValue[0]){
              parameterCodeArr.push(fieldValue[0].id);
              parameterCodeDisplayNameArr.push(fieldValue[0].id);
            }else{
              parameterCodeArr.push(fieldValue);
              parameterCodeDisplayNameArr.push(fieldValue);
            }
          }
        } else {
          parameterCodeArr.push(fieldValue);
          parameterCodeDisplayNameArr.push(fieldValue);
        }
      } 
      // else if condtion will run when we are saving placement and didn't select parameter for dropdowns
      else if(saveFlag){
        parameterCodeSchemaArr.push(field.name);
        parameterCodeArr.push('NU');
        parameterCodeDisplayNameArr.push('NU');
      }
      if (this.state.defaultTaxonomyData?.fields.length === index + 1) {
        formData["Parameter Code Schema"] = parameterCodeSchemaArr.join('|');
        formData["Parameter Code"] = PlacementDetailsTableService.createStringFromArray(this.state.defaultTaxonomyData.fields,parameterCodeArr,parameterCodeSchemaArr);
        formData["Parameter Code Display Name"] = PlacementDetailsTableService.createStringFromArray(this.state.defaultTaxonomyData.fields,parameterCodeDisplayNameArr,parameterCodeSchemaArr);
        this.setState({ formData: formData });
      }
    });
  };

  /**
   * Calculate Rate, Unit or Planned Cost based on the other two values
   * Check if new placement is created the assign value of publisher and Buy type 
   * and Call budget table function
   */
  getCost = () => {
    let formData = { ...this.state.formData };
    let costMethod = formData["costMethod"];
    // In case of Flat or Free, no calculation. is needed
    if (!["Flat", "Free"].includes(costMethod)) {
      //Divide the units by 1000 if "Cost Method" string contains CPM (Ex. CPM, dCPM, etc.)
      let units = formData["Unit Amount"];
      let rate = formData["Rate"];
      let cost = formData["Planned Cost"];

      let costValues = PlacementUtils.getCostCalculation(units, rate, cost, costMethod, this.feeCalcParam);

      units = costValues.units;
      rate = costValues.rate;
      cost = costValues.cost;

      let errorForm = { ...this.state.errorForm };

      if (units && (units?.toString().indexOf(".") > -1)) {
        errorForm["Unit Amount"] = true;
      } else {
        errorForm["Unit Amount"] = false;
      }

      formData["Unit Amount"] = Math.floor(units);
      formData["Rate"] = rate;
      formData["Planned Cost"] = cost;
      this.isFormDirty(formData);
      this.setState({ formData: formData, errorForm });
    }
    //get value from form if we are creating new placement
    if (this.placementType && this.publisherName && this.props.placementNestedData) {
      this.createBudgetTableData(formData["Planned Cost"], this.placementType, this.publisherName);
    }
    if (this.props.placementCategory?.title === 'Package' && this.props.placementCategory?.type.includes("Programmatic")) {
      this.getProgramaticPayload(formData);
    }
  };

  /**
   * Function to check for the invalid characters in the input field
   * @param {Object} e - Event object
   * @returns {void}
  */ 
  blockInvalidChar = (type, event) => {
    let excludedKeys = ['e', 'E', '+', '-'];
    if(type === 'Units'){
      excludedKeys.push('.');
    } else if(type === 'markupPercent' || type === 'margin'){
      excludedKeys = ['e', 'E', '+'];
    }
    excludedKeys.includes(event?.key) && event?.preventDefault();
  }

  /**
   * Returns a list of accordions for the taxonomy media mix section.
   * @returns {Array} A list of accordions.
   */
  getTaxanomyMediaMixAccordion = () => {
    this.loadTaxanomyAccordion();
    return this.taxonomyAccordions.map((accordion, index) => {
      return (
        <div key={`modal_section_${index}`} className={index !== this.taxonomyAccordions.length - 1 ? 'accordionSection' : ''}>
        {index === 1 && (
          <div className="placement-create-container sub-header parameter-code" key={accordion.header + index + "preview"}>
          <span className="placement-create-Header">Parameter Code (Preview)</span>
          <div className="input-container p-0 placement-name">
            <input
              id="parameter_code"
              type="text"
              className="input text full-width"
              disabled
              onChange={this.onDataChange.bind(this, "Parameter Code")}
              value={this.state.formData["Parameter Code"]}
              placeholder={`Parameter code is auto-generated via  ${this.props.placementCategory?.title} parameters  below`}
            ></input>
          </div>
        </div>
        )}
        <AccordionComponent
          accordion={{...accordion, isOpen: true}}
          key={accordion.header + index}
        ></AccordionComponent>
        </div>
      );
    });
  };

  /**
   * The below function validates the text as per the regex and sets the error state accordingly
   * @param {String} field - The field name
   * @param {Object} event - The event object
   * @returns {void}
   */
  textFieldValidator = (fieldName, field, event) => {
      if(field){
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        let  value = event.target.value;
        let delimiter = field.delimiter_value;
        let hasError = false;

        // Mark field as touched
        const touchedFields = { ...this.state.touchedFields };
        touchedFields[fieldName] = true;

        // Check for delimiter error
        if(delimiter && value.includes(delimiter)){
          hasError = true;
        }

        // Check for space error if allowed_space is false
        if(field.allowed_space === false && value.includes(' ')){
          hasError = true;
        }

        let errorForm = { ...this.state.errorForm };
        if(hasError){
          errorForm[fieldName] = true;
        } else {
          errorForm[fieldName] = false;
        }
        
        this.setState({ 
          errorForm, 
          touchedFields 
        }, () => {
          this.onDataChange(fieldName, {target: {value: value}}, null, false, {caretStart, caretEnd}, event);
        });
      }
  }

  /**
   * Handles the positioning and visibility of dropdown options list based on different event types.
   * 
   * @param {Event} event - The event object triggered by user interaction.
   * @param {string} key - A unique key for identifying the dropdown element.
   * @param {Object} field - The field object containing information like name.
   * @param {string} type - The type of event that triggered the function (e.g., 'click', 'blur', 'keyup').
   */

  handleFieldsWithSearchBlur = (event, key, field) => {
    // If the current dropdown element does not contain the active element, remove the 'opened' attribute and 'adjust-dropdown' class
    if(!document.getElementById(field.name + key).contains(document.activeElement)){
      document.getElementById(field.name + key).removeAttribute('opened')
      document.getElementById(field.name + key).classList.remove('adjust-dropdown')
    }
  };
  
  handleFieldsWithSearchClick = (event, key, field) => {
    // If there is an element with the class 'adjust-dropdown', remove that class
    if(document.querySelector('.adjust-dropdown')){
      document.querySelector('.adjust-dropdown').classList.remove('adjust-dropdown')
    }
    // Add the 'adjust-dropdown' class to the current dropdown element and adjust its position
    document.getElementById(field.name + key).classList.add('adjust-dropdown')
    this.adjustDropdownPosition()
  };

  handleFieldsWithSearchKeyup = (event, key, field) => {
    // If the 'Tab' key is pressed, set the 'opened' attribute to true and add the 'adjust-dropdown' class, then adjust its position
    if(event.key === 'Tab'){
      document.getElementById(field.name + key).setAttribute('opened', true)
      document.getElementById(field.name + key).classList.add('adjust-dropdown')
      setTimeout(() => {this.adjustDropdownPosition()},1)
    }
    // If the 'Enter' key is pressed, remove the 'adjust-dropdown' class and 'opened' attribute from the current dropdown element
    if(event.key === 'Enter'){
      if(document.querySelector('.adjust-dropdown')){
        document.querySelector('.adjust-dropdown').classList.remove('adjust-dropdown')
      }
      document.getElementById(field.name + key).removeAttribute('opened')
    }
  };

  /**
   * Handles the input for fields with search dropdowns, specifically for the 'Dimensions' field.
   * 
   * @param {Event} event - The event object triggered by user interaction.
   * @param {Object} field - The field object containing information like name and alias.
   * @param {RegExp} validationPattern - The regular expression pattern used for validating the input value.
   */
  handleFieldsWithSearchDropdown = (event, field, validationPattern) => {
    // Get the first value of the dropdown selection
    let inputValue = event.target.value[0];
    // Check if the field name or alias is 'Dimensions' and the input value is a string
    if((field.name === 'Dimensions' || field.alias === 'Dimensions') && typeof inputValue === 'string'){
      inputValue = inputValue.replace(/x/g, " x ").replace(/-/g, " - ");
      inputValue = inputValue.replace(/\s+/g, " ");
      // Update the dropdown value with the modified input value
      if(validationPattern.test(inputValue)){
        event.target.value[0] = inputValue;
        this.setState({validationFlag: false});
      }else{
        event.target.value[0] = '';
        this.setState({validationFlag: true});
      }
    }else if((field.name === 'Dimensions' || field.alias === 'Dimensions') && (typeof inputValue === 'object' && inputValue.value !== '')){
      this.setState({validationFlag: false});
    }
    let type = field.name === 'CPC Calculation Type' ? field.name : "Parameter Code "+field.name

    // delete the MO error field message after update
    if(this.moErrorFields[field.name]){
      delete this.moErrorFields[field.name];
    }
    
    this.onDataChange(type, event,field)
  };

  /**
   * Determines whether to show a field error based on the selected value and mandatory status.
   * @param {any} selectedValue - The value of the field to be checked. Can be an array or a single value.
   * @param {boolean} mandatory - Indicates whether the field is mandatory.
   * @returns {boolean} - Returns true if the field should show an error, otherwise false.
   */
  showFieldError = (selectedValue, mandatory, fieldName = null) => { 
    const value = Array.isArray(selectedValue) ? selectedValue.length : selectedValue;
    const isFieldTouched = fieldName ? this.state.touchedFields[fieldName] : false;
    
    // Only show error if field is touched (or during save attempt when emptyFieldError is true)
    return (!value && mandatory) && (isFieldTouched || (this.isSaveDisabled && this.state.emptyFieldError));
  };

  /**
   * Handles paste events by removing spaces when pasting into fields where spaces are not allowed
   * @param {Event} event - The paste event
   * @param {string} fieldName - The name of the field being modified
   * @param {Object} field - Field configuration that may include allowed_space property
   */
  handlePaste = (event, fieldName, field) => {
    // Check if this is a field where spaces should be removed
    const shouldRemoveSpaces = field && field.allowed_space === false;
    
    if (shouldRemoveSpaces) {
      // Prevent default paste behavior
      event.preventDefault();
      
      // Get the clipboard data
      const clipboardData = event.clipboardData || window.clipboardData;
      let pastedText = clipboardData.getData('text');
      
      if (pastedText && typeof pastedText === 'string') {
        // Remove all spaces from the pasted content
        const cleanedText = pastedText.replace(/\s+/g, '');
        
        // Update form data directly rather than manipulating the DOM
        const formData = {...this.state.formData};
        formData[fieldName] = formData[fieldName] ? formData[fieldName] + cleanedText : cleanedText;
        
        this.setState({
          formData: formData
        }, () => {
          // Optional: Trigger validation after state update if needed
          if (typeof this.validateField === 'function') {
            this.validateField(fieldName);
          }
        });
      }
    }
  };

  /**
   * Renders a dropdown component with search functionality and custom validation for specific fields.
   * @param {string} key - A unique key for the dropdown component.
   * @param {number} index - The index of the current field in the list of fields.
   * @param {Object} field - The field object containing information like name, alias, and whether it's mandatory or disabled.
   * @param {Array} options - The list of options to be displayed in the dropdown.
   * @param {Object} selectedOption - The currently selected option in the dropdown.
   * @param {boolean} enableHelperText - Flag to determine if helper text should be displayed.
   * @param {RegExp} validationPattern - The regular expression pattern used for validating the input. 
   * @returns {JSX.Element} A JSX element representing the dropdown component with custom validation and search functionality.
   */
  parameterCodeFieldsWithSearch = (key , index, field, options, selectedOption, enableHelperText, validationPattern) => {
    if(field.name === 'CPC Calculation Type' && this.state.formData[field.name]){
      selectedOption = [{value: this.state.formData[field.name], id: this.state.formData[field.name]}]
    }
    const showError = this.showFieldError(selectedOption.length, field.mandatory, "Parameter Code " + field.name) || this.moErrorFields[field.name]; // Flag to determine if the error message should be displayed for the current field
    const hideAdServerAndVerification = ["Ad Server","Ad Verification"].includes(field.name) ? this.checkAdServerOrVerifocationFeeCards(field): false;
    return(
      <div
      className={`input-container ${field.disabled ? 'disabled' : ''} ${showError ? 'error-label' : ''} ${hideAdServerAndVerification? 'hide-Ad-Serveror-verification' : ''}`}
      key={key}
      >
        <label className="dimensionsDropdownLabel" htmlFor={field.name + index}> 
          {field.mandatory && <>* </>}{field.alias?field.alias:field.name}
          { (field.name === 'Dimensions' || field.alias === 'Dimensions') &&
          <OmniTooltipNextComponent>
            <omni-icon slot="invoker" class="is-size-4" icon-id="omni:informative:info"></omni-icon>
            <div slot="content">Correct dimension format example: 100 x 100 - Demo Text 1</div>
          </OmniTooltipNextComponent>}
        </label>
        <OmniDropdownComponent
        typeahead
        searchindropdown
        noselect={options.length === 1 && options[0].value === 'No ordering vendors available'}
        virtualizedOptions
        options={options}
        fieldid={field.id}
        id={field.name + key}
        value={selectedOption}
        disabled={field.disabled}
        fieldtype="parameter_code"
        placeholder='Select Option'
        className={"dimensionsDropdown " + (showError ? 'error-field' : '')}
        hidefooter={!this.state.validationFlag}
        fieldname={"Parameter Code "+field.name}
        onBlur={(event) => this.handleFieldsWithSearchBlur(event, key, field, 'blur')}
        onClick={(event) => this.handleFieldsWithSearchClick(event, key, field, 'click')}
        onKeyUp={(event) => this.handleFieldsWithSearchKeyup(event, key, field, 'keyup')} 
        onDropdownChange={(event) => this.handleFieldsWithSearchDropdown(event, field, validationPattern)}
        error={(field.name === 'Dimensions' || field.alias === 'Dimensions') && this.state.validationFlag ? "Wrong format entry, see info example" : false}
        dynamicadditions={(field.name === 'Dimensions' || field.alias === 'Dimensions')||(field.name === 'Dimension/Positions' || field.alias === 'Dimension/Positions')}
        ></OmniDropdownComponent>
        {(showError && !this.moErrorFields[field.name]) && <span className="error-helper-text">{field.alias?field.alias:field.name} is required</span>}
        {(showError && this.moErrorFields[field.name]) && <span className="error-helper-text">{this.moErrorFields[field.name]}</span>}
        {enableHelperText && <span className="unitErrorMsg">No supplier has been mapped</span>}
        {field.showExplicitInfo && <span className="error-helper-text">This field is explicitly mapped with {field.parentFieldName}, hence no value is mapped to the selected parent value</span>}
      </div>
    )
  }
  
  /**
   * Create all fields of modal from defual field and taxonomy fields
   */
  loadTaxanomyAccordion = () => {
    this.taxonomyAccordions = [];
    const formData = { ...this.state.formData };
    let placementParametersObj = {
      header: `${
        this.getHeaderName()
      } Parameters`,
      content: [],
      tooltipMessage:
        'Some fields are disabled in Taxonomy builder and cannot be selected. The available fields default value is set as "Not used", and if not selected it will show as "NU" in your taxonomy name.',
    };
    let placementTaxonomyObj = {
      header: `${
        this.getHeaderName()
      } Taxonomy (Required)`,
      content: [],
    };

    const validationPattern = /^\d{1,5}\s?x\s?\d{1,5}(?:\s?-\s?[^ ].{0,19})?$/;
    let supplierAndSupplierCodeFields = [];
    let ServedByField = '';

    let estimateImpressionOption = impressionsMethod;
    placementParametersObj.content.push(
      <div className='placement-create-section' key='parmeterCodeDetails'>
        {this.state?.defaultTaxonomyData?.fields &&
          this.state?.defaultTaxonomyData?.fields.length > 0 &&
          this.state.defaultTaxonomyData.fields.map((field, index) => {
              let key = "parameter_code_"+index;

              if (field.field_type === 1 || field.field_type === 7) {
                // dropdown field
                let options = [];
                let selectedOption = []
                for (const fieldItem of field.fielditems) {
                  options.push({
                    value: fieldItem.name,
                    id: fieldItem.code
                  });
                  // Case-insensitive comparison to handle state values in different cases
                  const formDataValue = this.state.formData["Parameter Code "+field.name];
                  if(fieldItem.code && formDataValue && 
                     fieldItem.code?.toLowerCase() === formDataValue?.toLowerCase()){
                    selectedOption = [{
                      value: fieldItem.name,
                      id: fieldItem.code
                    }]
                  }
                }
                
                
                let enableHelperText = false; // Check if the current field is either 'Supplier' or 'Supplier Code' by checking both its alias and name
                if(field.name === 'Supplier' || field.alias === 'Supplier'){
                  /**
                   * The filterOptions function is a JavaScript function that takes an object called campaignObj as input. Its job is to filter a list of partners from the campaign
                   * and create a dropdown menu with only the relevant options. Each option in the dropdown is represented as an object containing a value (the name of the partner)
                   * and an id (a unique identifier for the partner). Finally, the function returns this filtered list of dropdown options.
                   * @param {Object} campaignObj - The campaign object containing information like partners.
                   * @returns {Array} - An array of objects containing the value and id of the partners.
                   */
                  // const filterOptions = this.props.campaignObj?.partners?.map(item => ({value: item, id: item}));
                  // options = filterOptions?.length ? filterOptions : [];
                  // selectedOption = filterOptions?.filter(item => item.value === this.state.formData["Parameter Code "+field.name]);
                  enableHelperText = !options.length;
                }
                
                // Check if the current field is either 'Supplier' or 'Supplier Code' by checking both its alias and name
                const isSupplierAndSupplierCode = ['Supplier', 'Supplier Code'].includes(field.alias) || ['Supplier', 'Supplier Code'].includes(field.name);
                // If the field is related to Supplier or Supplier Code
                if(isSupplierAndSupplierCode){
                  // Add the field to the supplierAndSupplierCodeFields array
                  supplierAndSupplierCodeFields.push(this.parameterCodeFieldsWithSearch(key, index, field, options, selectedOption, enableHelperText, validationPattern));
                } else if(field.name === 'Served By' || field.alias === 'Served By'){
                  ServedByField = this.parameterCodeFieldsWithSearch(key, index, field, options, selectedOption, enableHelperText, validationPattern);
                } else{
                  // If the field is not related to Supplier or Supplier Code, directly return the dropdown/search component
                return this.parameterCodeFieldsWithSearch(key, index, field, options, selectedOption, enableHelperText, validationPattern);
                }
              } else if (field.field_type === 2) {
                // input field
                const showError = this.showFieldError(this.state.formData["Parameter Code "+field.name], field.mandatory) || this.state.errorForm["Parameter Code "+field.name]; 
                const dropdown = (
                  <div className="input-container" key={key}> 
                    <label htmlFor={field.name + index} className={showError ? "error-label" : ""}> {field.mandatory && <>* </>}{field.alias?field.alias:field.name}</label>
                    <input
                      id={field.name + index}
                      className={this.state.errorForm["Parameter Code "+field.name] || (this.showFieldError(this.state.formData["Parameter Code "+field.name], field.mandatory) && this.state.emptyFieldError) ? "error-input" : ""}
                      fieldtype="parameter_code"
                      fieldid={field.id}
                      value={this.state.formData["Parameter Code "+field.name]}
                      key={field.name + key}
                      fieldname = {"Parameter Code "+field.name}
                      onChange={(event) => this.textFieldValidator("Parameter Code "+field.name, field,  event)}
                      onPaste={(e) => this.handlePaste(e, field.name, field)}
                      maxLength={field.character_limit}
                      placeholder={field.name}
                      disabled= {field.disabled} 
                    ></input>
                    {showError && <span className="error-helper-text">{!this.state.formData["Parameter Code "+field.name] ? `${field.alias?field.alias:field.name} is required`: `Text should not contains field delimiter ( ${field.delimiter_value} )${field?.allowed_space === false ? ' & Space is not allowed.': '.'}`}</span>}
                  </div>
                );
                const isSite = ['Site'].includes(field.alias) || ['Site'].includes(field.name); // Check if the current field is either 'Site' by checking both its alias and name
                if (isSite) {
                  supplierAndSupplierCodeFields.push(dropdown); // Add the field to the supplierAndSupplierCodeFields array
                } else {
                  return dropdown; // If the field is not related to Supplier or Supplier Code, directly return the dropdown/search component
                }
              } else if (field.field_type === 5) {
                // date field
                const showError = this.showFieldError(this.state.formData["Parameter Code "+field.name], field.mandatory); // Check if the field is mandatory and if there is no value in the form data and set the error flag

                return (
                  <div className={`input-container`} key={index}>
                    <label htmlFor={field.name + index} className={showError ? "error-label" : ""}>
                      {field.mandatory && <>* </>}
                      {field.alias?field.alias:field.name}
                    </label>
                    <input
                      data-date={Utils.parseDateToFormat(this.state.formData["Parameter Code "+field.name], field.dateFormat)}
                      id={field.name + index}
                      key={field.name + index}
                      type='date'
                      fieldtype="taxonomy"
                      fieldid={field.id}
                      fieldname = {field.name}
                      className={showError ? "error-input" : ""}
                      onChange={(e) => this.onDataChange(field.name, e)}
                      value={this.state.formData[field.name] ? this.state.formData[field.name]: ""}
                      placeholder={field.name}
                      style= {{position: "relative"}}
                    ></input>
                    {showError && <span className="error-helper-text">{field.alias?field.alias:field.name} is required</span>}
                  </div>
                );
              } else if (field.field_type === 6) {
                // number field
                const showError = this.showFieldError(this.state.formData["Parameter Code "+field.name], field.mandatory); // Check if the field is mandatory and if there is no value in the form data and set the error flag

                return (
                  <div className={`input-container` + showError ? "error-label" : ""} key={index}>
                    <label htmlFor={field.name + index}>
                      {field.mandatory && <>* </>}
                      {field.alias?field.alias:field.name}
                    </label>
                    <input
                      id={field.name + index}
                      key={field.name + index}
                      type='number'
                      fieldtype="taxonomy"
                      fieldid={field.id}
                      fieldname = {field.name}
                      className={showError ? "error-input" : ""}
                      onChange={(e) => this.onDataChange(field.name, e)}
                      value={this.state.formData[field.name]}
                    ></input>
                    {showError && <span className="error-helper-text">{field.alias?field.alias:field.name} is required</span>}
                  </div>
                );
              }else if (field.field_type === 9 || field.field_type === 10) {
                // static field or taxonomy id field
                return PlacementDetailsTableService.getStaticField(index, field, this.state);
              }
          })
          }
          
          {this.state.formData['Parameter Code Cost Method'] === 'CPC' &&
            this.parameterCodeFieldsWithSearch('CPC Calculation Type', '', {name:'CPC Calculation Type',mandatory:true}, estimateImpressionOption, [], false, validationPattern)
          }         
      </div>
    );

    // Push `Served By` field to last
    supplierAndSupplierCodeFields.push(ServedByField);

    placementTaxonomyObj.content.push(
      <React.Fragment key='placementDetails'>
      <div className='placement-create-section'>
        {supplierAndSupplierCodeFields.map((field) => field)}
      </div>
      <div className='placement-create-section' >
        {this.state?.taxonomyData?.fields &&
          this.state?.taxonomyData?.fields.length > 0 &&
          this.state.taxonomyData.fields.map((field, index) => {
              let key = field.name + index;
              if (field.field_type === 1 || field.field_type === 7) {
                // dropdown field
                const options = [];
                let fieldValue = [];
                for (const fieldItem of field.fielditems) {
                  options.push({
                    value: fieldItem.name,
                    id: fieldItem.code
                  });
                  // Case-insensitive comparison to handle state values in different cases
                  const formDataByName = this.state.formData[field.name];
                  const formDataByAlias = this.state.formData[field.alias];
                  
                  if((fieldItem.code && formDataByName && 
                      fieldItem.code?.toLowerCase() === formDataByName?.toLowerCase()) ||
                     (fieldItem.code && formDataByAlias && 
                      fieldItem.code?.toLowerCase() === formDataByAlias?.toLowerCase())){
                    fieldValue = [{
                      value: fieldItem.name,
                      id: fieldItem.code
                    }]
                  }
                }

                const showError = this.showFieldError(fieldValue, field.mandatory, field.name); // Check if the field is mandatory and if there is no value in the form data and set the error flag

                return (
                  <div className={`input-container`} key={key}>
                    <label htmlFor={field.name + index} className={showError ? "error-label" : ""}>
                      {field.mandatory && <>* </>}
                      {field.alias?field.alias:field.name}
                    </label>
                    <OmniDropdownComponent
                      onBlur={() => {
                        if(!document.getElementById(field.name + key).contains(document.activeElement)){
                          document.getElementById(field.name + key).removeAttribute('opened')
                          document.getElementById(field.name + key).classList.remove('adjust-dropdown')
                        }
                      }}
                      onClick={() => {
                        if(document.querySelector('.adjust-dropdown')){
                          document.querySelector('.adjust-dropdown').classList.remove('adjust-dropdown')
                        }
                        document.getElementById(field.name + key).classList.add('adjust-dropdown')
                        this.adjustDropdownPosition()
                      }}
                      onKeyUp={(event) => {
                        if(event.key === 'Tab'){
                          document.getElementById(field.name + key).setAttribute('opened', true)
                          document.getElementById(field.name + key).classList.add('adjust-dropdown')
                          setTimeout(() => {this.adjustDropdownPosition()},1)
                        }
                        if(event.key === 'Enter'){
                          if(document.querySelector('.adjust-dropdown')){
                            document.querySelector('.adjust-dropdown').classList.remove('adjust-dropdown')
                          }
                          document.getElementById(field.name + key).removeAttribute('opened')
                        }
                      }} 
                      hidefooter={!this.state.validationFlag}
                      typeahead
                      searchindropdown
                      id={field.name + key}
                      fieldtype="taxonomy"
                      fieldid={field.id}
                      fieldname = {field.name}
                      value={fieldValue}
                      options={options}
                      placeholder='Select Option'
                      className={"dimensionsDropdown " + (showError ? "error-field" : "")}
                      onDropdownChange={
                        (e) => this.onDataChange(field.name, e, field) //send field parameter for cascading logic
                      }
                    ></OmniDropdownComponent>
                    {showError && <span className="error-helper-text">{field.alias?field.alias:field.name} is required</span>}
                    {field.showExplicitInfo && <span className="error-helper-text">This field is explicitly mapped with {field.parentFieldName}, hence no value is mapped to the selected parent value</span>}
                  </div>
                );
              } else if (field.field_type === 2) {
                // input field
                const showError = this.showFieldError(this.state.formData[field.name], field.mandatory, field.name) || this.state.errorForm[field.name];
                return (
                  <div className={`input-container`} key={index}>
                    <label htmlFor={field.name + index} className={showError ? "error-label" : ""}>
                      {field.mandatory && <>* </>}
                      {field.alias?field.alias:field.name}
                    </label>
                    <input
                      id={field.name + index}
                      className={this.state.errorForm[field.name] || (this.showFieldError(this.state.formData[field.name], field.mandatory) && this.state.emptyFieldError) ? "error-input" : ""}
                      key={field.name + index}
                      fieldtype="taxonomy"
                      fieldid={field.id}
                      fieldname = {field.name}
                      onChange={(e) => this.textFieldValidator(field.name, field, e)}
                      onPaste={(e) => this.handlePaste(e, field.name, field)}
                      maxLength={field.character_limit}
                      value={this.state.formData[field.name]}
                      placeholder={field.name}
                    ></input>
                    {showError && <span className="error-helper-text">{!this.state.formData[field.name] ? `${field.alias ? field.alias : field.name} is required`: `Text should not contains field delimiter ( ${field.delimiter_value} )${field?.allowed_space === false ? ' & Space is not allowed.': '.'}`}</span>}
                  </div>
                );
              } else if (field.field_type === 5) {
                // date field
                const showError = this.showFieldError(this.state.formData[field.name], field.mandatory); // Check if the field is mandatory and if there is no value in the form data and set the error flag

                return (
                  <div className={`input-container`} key={index}>
                    <label htmlFor={field.name + index} className={showError ? "error-label" : ""}>
                      {field.mandatory && <>* </>}
                      {field.alias?field.alias:field.name}
                    </label>
                    <input
                      data-date={Utils.parseDateToFormat(this.state.formData[field.name], field.dateFormat)}
                      id={field.name + index}
                      key={field.name + index}
                      type='date'
                      fieldtype="taxonomy"
                      fieldid={field.id}
                      fieldname = {field.name}
                      className={showError ? "error-input" : ""}
                      onChange={(e) => this.onDataChange(field.name, e)}
                      value={this.state.formData[field.name] ? this.state.formData[field.name]: ""}
                      placeholder={field.name}
                      style= {{position: "relative"}}
                    ></input>
                    {showError && <span className="error-helper-text">{field.alias?field.alias:field.name} is required</span>}
                  </div>
                );
              } else if (field.field_type === 6) {
                // number field
                const showError = this.showFieldError(this.state.formData[field.name], field.mandatory); // Check if the field is mandatory and if there is no value in the form data and set the error flag

                return (
                  <div className={`input-container` + showError ? "error-label" : ""} key={index}>
                    <label htmlFor={field.name + index}>
                      {field.mandatory && <>* </>}
                      {field.alias?field.alias:field.name}
                    </label>
                    <input
                      id={field.name + index}
                      key={field.name + index}
                      type='number'
                      fieldtype="taxonomy"
                      fieldid={field.id}
                      fieldname = {field.name}
                      className={showError ? "error-input" : ""}
                      onChange={(e) => this.onDataChange(field.name, e)}
                      value={this.state.formData[field.name]}
                    ></input>
                    {showError && <span className="error-helper-text">{field.alias?field.alias:field.name} is required</span>}
                  </div>
                );
              }else if (field.field_type === 9 || field.field_type === 10) {
                // static field or taxonomy id field
                return PlacementDetailsTableService.getStaticField(index, field, this.state);
              } else if (field?.field_type === 3) {
                if (field?.taxonomy_id === this.props.allTaxonomyData['campaignTaxonomyData']?.id && this.state.formData[field.name]) {
                  return (
                    <div className="input-container">
                      <label htmlFor={field.name + index}>
                        {field.alias ? field.alias : field.name}
                      </label>
                      <input id={field.name + index} disabled value={this.state.formData[field.name]}></input>
                    </div>
                  )
                }
              }
          })
          }
      </div>
      </React.Fragment>
    );

    this.taxonomyAccordions.push(placementTaxonomyObj);
    this.taxonomyAccordions.push(placementParametersObj);
    this.loadDatesAndPricingAccordions();
  };

  /**
   * Set drop down value in Ad verification and Ad serving 
   * @param {string} buyType if 'buytype' avilable then
   * get value from campaign detail if buy type match with channel name
   * @returns Object, return ad serving and verification option list in array inside object.
   */
  setAdOptions(buyType){
    let adServingOption = [];
    let adVerificationOption = [];
    if(buyType){
      let channel = this.props.campaignObj?.channels.find(val=>{
        return val.channel_name === buyType;
      });
      channel?.publishers.forEach(val=>{
        if(val.publisher_type ==='Ad Serving'){
          adServingOption.push({
            value : val.publisher_name,
            label : val.publisher_name
          })
        }else if(val.publisher_type ==='Ad Verification'){
          adVerificationOption.push({
            value : val.publisher_name,
            label : val.publisher_name
          })
        }
      });
    }

    let adServerSchemaOption = this.state.defaultTaxonomyData?.fields.find(item=> item.name === 'Ad Server');
    let adVerificationSchemaOption = this.state.defaultTaxonomyData?.fields.find(item=> item.name === 'Ad Verification');    
    return {
      adServingMatchedValue:this.getValueAfterCompareTwoArray(adServerSchemaOption?.fielditems,adServingOption),
      adVerificationMatchedValue:this.getValueAfterCompareTwoArray(adVerificationSchemaOption?.fielditems,adVerificationOption),
    }
  }

  /**
   * The below function will trigger on change of Add markup checkbox
   * It will cler the value of billable rate, billable, margin and markup percent if checkbox is unchecked else it will set the value
   * Also it will show the info message if rate, unit and planned cost is not entered
   * @param {Object} checkBoxEvent - Event object
   * @returns {void}
  */ 
  onMarkupCheckboxChange = (checkBoxEvent) => {
    if((this.state.formData['Rate']  || (this.state.formData['Rate'] == 0 && this.state.formData['costMethod'] === "Flat")) &&
      this.state.formData['Unit Amount'] && this.state.formData['Planned Cost']) {
      let formData = { ...this.state.formData };
      if(!checkBoxEvent.target.__checked){
        formData['billableRate'] = formData['billable'] = formData['margin'] = formData['markupPercent'] = '';
      }
      this.fieldIsUpdated = true;
      this.setState({ formData: { ...formData, isAddMarkup: checkBoxEvent.target.__checked } });
    } else {
      checkBoxEvent.target.__checked = false;
      AlertMessagesService.showInfoToastMessage("Please enter Rate, Units and Planned Cost to calculate markup");
    }
  }

  /**
   * The below function will trigger on change of any of the markup fields.
   * It will calculate the value of other fields based on the changed field
   * @param {String} dataType - The type of data that is changed
   * @param {Object} event - Event object
   * @returns {void}
  */ 
  onBillableDataChange = (dataType, event) => {
    // If any of the field is empty then clear all the fields
    if(!event.target.value){
      let formData = { ...this.state.formData };
      formData['billableRate'] = formData['billable'] = formData['margin'] = formData['markupPercent'] = '';
      this.setState({ formData: formData });
      return;
    }
    let updatedFormData = PlacementUtils.calculateMarkup(this.state.formData, dataType, event.target.value);
    if(updatedFormData){
      this.setState({ formData: updatedFormData });
    }
    this.fieldIsUpdated = true;
  }

  /**
   * Loads the dates and pricing accordions for the placement creation section.
   * This function creates a section with input fields for start date, end date, rate, units, cost amount, 
   * ad server fee, and ad verification fee. It also includes error handling and validation for required fields.
  */
  loadDatesAndPricingAccordions = () => {
    let datesAndPricingObj = { header: "Dates And Pricing", content: [] };
    // Initialize error flags for start date, end date, rate, and units
    const showStartDateError = this.showFieldError(this.state.formData["Flight Start"], true, "Flight Start");
    const showEndDateError = this.showFieldError(this.state.formData["Flight End"], true, "Flight End");
    const showRateError = this.showFieldError(this.state.formData["Rate"], true, "Rate");
    const showUnitAmountError = this.showFieldError(this.state.formData["Unit Amount"], true, "Unit Amount");
    const showPlannedCostError = this.showFieldError(this.state.formData["Planned Cost"], true, "Planned Cost");
    // Check if rate and units are required based on programmatic type and main type
    const rateAndUnitsIsRequired = (this.props.placementCategory?.title === "Package" && this.props.placementCategory?.type.includes('Programmatic'))

    datesAndPricingObj.content.push(
      <React.Fragment key="datesAndPrices">
        <div className="dateSectionBorder">
          <div className="placement-create-section">
            <div className="input-container">
              <label htmlFor="campaignStartDate" className={showStartDateError ? "error-label" : ""}>
                <>* </>Start Date
              </label>
              <div className="date-field">
                <input
                  id="Flight Start" 
                  data-date={ (this.state.formData["Flight Start"] !== "" ) ? Utils.formatDateObject(this.state.formData["Flight Start"]) :"Mon DD, YYYY"}
                  type="date"
                  // min={this.props.campaignObj['start_date']}
                  // max={this.props.campaignObj['end_date']}
                  className="input text is-small"
                  onChange={this.onDataChange.bind(this, "Flight Start")}
                  value={PlacementDetailsTableService.converDateToYMDFormat(this.state.formData["Flight Start"])}
                />
              </div>
            </div>
            <div className="input-container">
              <label htmlFor="campaignStartDate" className={showEndDateError ? "error-label" : ""}>
                <>* </>End Date
              </label>
              <div className="date-field">
                <input
                  id="Flight End"
                  data-date={ (this.state.formData["Flight End"] !== "") ? Utils.formatDateObject(this.state.formData["Flight End"]) :"Mon DD, YYYY"}
                  type="date"
                  // min={PlacementDetailsTableService.converDateToYMDFormat(this.state.formData["Flight Start"])}
                  // max={this.props.campaignObj['end_date']}
                  className="input text is-small"
                  onChange={this.onDataChange.bind(this, "Flight End")}
                  value={PlacementDetailsTableService.converDateToYMDFormat(this.state.formData["Flight End"])}
                ></input>
              </div>
            </div>

            <div className="input-container">
              <label>Active date range</label>
              <div className="date-range" id="dateRange">
                {this.getDateRange() }
              </div>
            </div>
            
            <div className="placement-create-section">
              {rateAndUnitsIsRequired && <div className="placement-line-placment-table-msg">Input the "Cost Amount" and press enter to create the line</div>}
              <div className="input-container">
                <label htmlFor="budget" className={(rateAndUnitsIsRequired && showRateError) ? "error-label" : ""}>{rateAndUnitsIsRequired && "* "}Rate</label>
                <OmniTooltipNextComponent>      
                  <input
                    id="Rate"
                    type="number"
                    min="0"
                    onKeyDown={(e) => this.blockInvalidChar('Rate', e)}
                    className={"input text is-small" + (rateAndUnitsIsRequired && showRateError ? "error-input" : "")}
                    onChange={(e) => this.onDataChange("Rate",e, null, true)}
                    value={this.state.formData["Rate"]}
                    placeholder="Enter Rate"
                    disabled={["Flat", "Free"].includes(this.state.formData['costMethod'])}
                  ></input>
                  <div slot="content">{["Flat", "Free"].includes(this.state.formData['costMethod']) ? 'On selection of Flat or Free as Cost Method, Rate will be disabled' : '' }</div>
                </OmniTooltipNextComponent>
                {(rateAndUnitsIsRequired && showRateError) && <span className="error-helper-text">Rate is required</span>}
              </div>
              <div className="cross">
                <span>X</span>
              </div>

              <div className="input-container">
                <label htmlFor="budget" className={(rateAndUnitsIsRequired && showUnitAmountError) ? "error-label" : ""}>{rateAndUnitsIsRequired && "* "}Units</label>
                  <input
                    id="units"
                    type="number"
                    min="0"
                    onKeyDown={(e) => this.blockInvalidChar('Units', e)}
                    className={"input text is-small" + (rateAndUnitsIsRequired && showRateError ? "error-input" : "")}
                    onChange={(e) => this.onDataChange("Unit Amount",e, null, true)}
                    value={this.state.formData["Unit Amount"]}
                    placeholder="Enter Units"
                  ></input> 
                {(rateAndUnitsIsRequired && showUnitAmountError) && <span className="error-helper-text">Units is required</span>}
                {
                this.state.formData["Unit Amount"] > 0 && this.state.errorForm["Unit Amount"] && <span className="unitErrorMsg">Units can not be a decimal. We have rounded down to the nearest whole number</span>
                }
              </div>
              <div className="input-container input-cost-container">
                <label htmlFor="budget" className={(rateAndUnitsIsRequired && showPlannedCostError) ? "error-label" : ""}>{rateAndUnitsIsRequired && "* "}Cost amount</label>
                <OmniTooltipNextComponent>
                  <input
                    id="cost"
                    type="number"
                    min="0"
                    onKeyDown={(e) => {(e.key === "Enter" && rateAndUnitsIsRequired) ? this.getProgramaticPayload():this.blockInvalidChar('Cost Amount', e)}}
                    className={"input text is-small" + (rateAndUnitsIsRequired && showRateError ? "error-input" : "")}
                    onChange={(e) => this.onDataChange("Planned Cost",e, null, true)}
                    value={this.state.formData["Planned Cost"]}
                    placeholder="Enter Cost amount"
                    disabled={["Free"].includes(this.state.formData['costMethod'])}
                  ></input>
                  <div slot="content">{["Free"].includes(this.state.formData['costMethod']) ? 'On selection of Free as Cost Method, Cost Amount will be disabled' : '' }</div>
                </OmniTooltipNextComponent>
                {(rateAndUnitsIsRequired && showPlannedCostError) && <span className="error-helper-text">Cost amount is required</span>}
                {
                (this.remainingProgramticPackageCost != null && this.remainingProgramticPackageCost < 0
                && <span  className="budget-Waring-msg">Cost is Over Budget</span>)
                }
              </div>

              <div className="input-container calculate">
                <button onClick={this.getCost} disabled={["Flat", "Free"].includes(this.state.formData['costMethod']) && !this.props.placementCategory?.type.includes("Programmatic")}>Calculate</button>
                <OmniTooltipNextComponent place="left">
                  <div slot="content">Entered 'Cost Amount' will not change on click of calculate button and only the 'Rate/Units' field value will be calculated based on 'Cost Amount' value</div>
                  <OmniIconComponent className="is-size-4 costInfoIcon" icon-id="omni:informative:info"></OmniIconComponent>
                </OmniTooltipNextComponent>
              </div>
            </div>
          </div>

          <div className="placement-create-section">
            <div className="input-container">
              <OmniCheckboxComponent
                checked = {this.state.formData["isAddMarkup"]}
                onCheckboxChange={(e) => this.onMarkupCheckboxChange(e)}>
                <label className="boldText">Add Markup</label>
              </OmniCheckboxComponent>
            </div>
          </div>

          <div className="placement-create-section">
            <div className="input-container">
            <label htmlFor="budget">Billable Rate</label>
            <input id="adserverfee" type="number" min="0" onKeyDown={(e) => this.blockInvalidChar('billableRate', e)} className="input text is-small" disabled={!this.state.formData["isAddMarkup"]}
                onChange={(e) => this.onBillableDataChange("billableRate", e)} value={this.state.formData["billableRate"]} placeholder="Enter Billable Rate"></input>
            </div>
            <div className="input-container">
            <label htmlFor="budget">Units</label>
            <input id="adserverfee" type="number" min="0" className="input text is-small" disabled value={this.state.formData["Unit Amount"]} placeholder="Enter Units"></input>
            </div>
            <div className="input-container">
            <label htmlFor="budget">Billable</label>
            <input id="adserverfee" type="number" min="0" onKeyDown={(e) => this.blockInvalidChar('billable', e)} className="input text is-small" disabled={!this.state.formData["isAddMarkup"]}
                onChange={(e) => this.onBillableDataChange("billable", e)} value={this.state.formData["billable"]} placeholder="Enter Billable"></input>
            </div>
            <div className="input-container">
            <label htmlFor="budget">Margin</label>
            <input id="adserverfee" type="number" onKeyDown={(e) => this.blockInvalidChar('margin', e)} className="input text is-small" disabled={!this.state.formData["isAddMarkup"]}
                onChange={(e) => this.onBillableDataChange("margin", e)} value={this.state.formData["margin"]} placeholder="Enter Margin"></input>
            </div>
            <div className="input-container">
            <label htmlFor="budget">Markup %</label>
            <input id="adserverfee" type="number" onKeyDown={(e) => this.blockInvalidChar('markupPercent', e)} className="input text is-small" disabled={!this.state.formData["isAddMarkup"]}
                onChange={(e) => this.onBillableDataChange("markupPercent", e)} value={this.state.formData["markupPercent"]} placeholder="Enter Markup %"></input>
            </div>
          </div>
        </div>
          
        <div>
          <div className="placement-create-section">
              <div className="input-container">
                  <OmniCheckboxComponent className="is-small paddingTop30" checked={this.state.formData["overrideAdservingFees"]}
                    onCheckboxChange={(e) => this.setState({ formData: { ...this.state.formData, overrideAdservingFees: e.target.__checked } })}>
                    <label className="boldText">Override Adserving Fees ?</label>
                  </OmniCheckboxComponent>
              </div>
              <div className="input-container">
                <label htmlFor="budget">
                  Ad Server Fee
                </label>
                <input
                  id="adserverfee"
                  type="number"
                  min="0"
                  onKeyDown={this.blockInvalidChar}
                  className="input text is-small"
                  disabled={!this.state.formData["overrideAdservingFees"]}
                  onChange={(e) => this.onDataChange("adserverfee", e)}
                  value={this.state.formData["adserverfee"]}
                  placeholder="Enter Ad Server Fee"
                ></input>
              </div>
              <div className="input-container">
                  <OmniCheckboxComponent className="is-small paddingTop30" checked={this.state.formData["overrideAdverificationFees"]} 
                  onCheckboxChange={(e) => this.setState({ formData: { ...this.state.formData, overrideAdverificationFees: e.target.__checked } })}>
                    <label className="boldText">Override Adverification Fees ?</label>
                  </OmniCheckboxComponent>
              </div>
              <div className="input-container">
                <label htmlFor="budget">
                  Ad Verification Fee
                </label>
                <input
                  id="adverificationfee"
                  type="number"
                  min="0"
                  onKeyDown={this.blockInvalidChar}
                  className="input text is-small"
                  disabled={!this.state.formData["overrideAdverificationFees"]}
                  onChange={(e) => this.onDataChange("adverificationfee", e)}
                  value={this.state.formData["adverificationfee"]}
                  placeholder="Enter Ad Verification Fee"
                ></input>
              </div>
          </div>  
          {this.budgetData.length ? (
          <div className="placement-create-section">
            <div className="placement-budget-table input-container">
              <OmniTableComponent
                class="card"
                id="placement-table"
                data={this.budgetData}
                columns={this.nestedColumns}
                key={this.budgetData.length}
              >            
              </OmniTableComponent>
            </div>
          </div>):(<div className="skeleton"></div>)
          }
        </div>
      </React.Fragment>
    );
    this.taxonomyAccordions.push(datesAndPricingObj);
  };

  nestedColumns = [
    {
      label: 'PROVIDER/CHANNEL(REFERENCE)',
      key: 'provider',
      default: '',
      isSortable: false,
      passthrough: false,
      template: (value, index) => {
          return html`
          <td part="table-body-cell" class="is-main">
            <span part="td-content">${value}</span>
        </td>`
      }
    },
    {
      label: 'BUDGET',
      key: 'budgets',
      default: '',
      isSortable: false,
      passthrough: false,
      template: (value, index) => {
          return html`
          <td part="table-body-cell">
            <span> ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(value).toLocaleString('en-US', { style: "currency", currency: "USD" })}</span>
          </td>`
      }
    },
    {
      label: 'TOTAL',
      key: 'total',
      default: '',
      isSortable: false,
      passthrough: false,
      template: (value, index) => {
          return html`
          <td part="table-body-cell">
            <span> ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(value)}</span>
          </td>`
      }
    },
  ]
  /**
   * create table of budget 
   * get all information for table total cost, channel name and budget, publisher name and budget
   * @param {number} cost total cost from unit and rate from current form
   * @param {string} buyType selected buy type current from
   * @param {string} publisher selected publisher from cureent form
   */
  createBudgetTableData(cost,buyType,publisher){
    this.budgetData = [];
    let channel = this.getSelectedChannel(buyType);
    let costList = this.getTotalCost(buyType,publisher)
    let channelTotal = cost + costList.channelCost;
    let publisherTotal = cost + costList.publisherCost;
    if(channel){
      this.budgetData =[
        {
          provider:buyType, budgets:channel.channel_total_budget,total:channelTotal
        }
      ]
      if(channel.publishers.length){
        channel.publishers.forEach((val)=>{
          if(publisher === val["publisher_name "]){
            let obj = {
              provider:val["publisher_name "], budgets:val.publisher_budget,total:publisherTotal
            }
            this.budgetData.push(obj);
          }
        });
      }
    }
  }


  getAllPlacement(buyType, publisherName){
    let placementNestedData = Utils.getObjectFromArray(buyType,this.props.placementNestedData,'placement_taxonomy')
    let publisherNestedData = null;
    if(placementNestedData){
      publisherNestedData = Utils.getObjectFromArray(publisherName,placementNestedData.nestedData,'placement_taxonomy')
    }
    return {placementNestedData:placementNestedData,publisherNestedData:publisherNestedData};
  }
  /**
   * get channel total cost
   * get publisher total cost
   * if editing placement then it will deduct placement cost from total publisher and channel cost
   * @param {string} buyType 
   * @param {string} publisherName 
   * @returns object with channel total cost and publisher total cost
   */
  getTotalCost(buyType, publisherName){
    const isLocal = this.props.systemParametersData.data.isLocal;
    const currency = isLocal && this.props.campaignObj.local_currency_name ? this.props.campaignObj.local_currency_name : 'USD';
    let plannedCost = isLocal && currency? 'planned_cost_local'  : 'planned_cost' ;
    let nestedDataList = this.getAllPlacement(buyType, publisherName);
    let channelCost = null
    let publisherCost = null;
    if(nestedDataList.placementNestedData){
      if(nestedDataList?.publisherNestedData){
        publisherCost = nestedDataList?.publisherNestedData[plannedCost];
      }
      channelCost = nestedDataList?.placementNestedData[plannedCost];
    }
   
    if(this.props.editDailog && nestedDataList.publisherNestedData && nestedDataList.publisherNestedData.nestedData.length){
      let placementObj = Utils.getObjectFromArray(this.props.placementData.id,nestedDataList.placementNestedData.nestedData,'id')
      publisherCost = placementObj ? publisherCost - placementObj[plannedCost]: publisherCost;
      channelCost = placementObj ? channelCost - placementObj[plannedCost] : channelCost;
    }
    return {channelCost:channelCost,publisherCost:publisherCost};
  }

  /**
   * get channel from campaign object that match with current selected channel
   * @param {string} type buy type  
   * @returns channel from list of comaign channel list
   */
  getSelectedChannel(type){
    let channel = null;
    this.props.campaignObj.channels.forEach((value,index)=>{
      if(value.channel_name === type){
        channel = value
      }
    });
    return channel;
  }

  /**
   * Returns the header name for the placement or package based on the programmaticType prop is set.
   * @returns {string} The header name.
   */
  getHeaderName = (payload=null) => {
    if(payload && payload[0]?.childLineItems){
      return 'Placement'
    } else if (this.props.placementCategory?.type) {
      return this.props.placementCategory?.type + ' ' + this.props.placementCategory?.title;
    } else {
      return 'Placement';
    }
  }  
  /**
   * Saves or updates the placement or package based on the provided conditions.
   * @param {boolean} add_next - Indicates whether to add the next item after saving or updating.
   * @param {boolean} fieldsAreEmpty - Indicates whether the required fields are empty.
   */
  saveOrUpdate = (add_next, fieldsAreEmpty) => {
    if (fieldsAreEmpty && !this.state.formData.isOverride) {
        // If fields are empty, set emptyFieldError to true and scroll to the first error field
        this.setState({ emptyFieldError: true }, () => {
            const errorFields = document.querySelector('.error-label');
            if (errorFields) {
                errorFields.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        });
    } else if (!this.fieldIsUpdated && !this.state.formData.isOverride) { // If fields are not updated, close the modal
        this.cancelPlacementModal();
    } else if (!this.fieldIsUpdated && this.props.editDailog) {
        this.cancelPlacementModal();
    } else {
        // If fields are not empty and fields are updated, proceed with saving or updating
        this.setState({ emptyFieldError: false });
        // Check if the total cost of child items exceeds the parent package cost for programmatic packages
        if (this.props.placementCategory?.title === 'Package' && this.props.placementCategory?.type.includes("Programmatic") && this.state.programmaticPackageData?.length) {
            let programmaticPackageData = this.state.programmaticPackageData[0];
            let totalCost = programmaticPackageData.placementCost.plannedCost.amount;
            let childTotalCost = 0;
            const calculateChildTotals = (programmaticPackageData) => {
              if (programmaticPackageData?.childLineItems) {
                for(let i=0;i<programmaticPackageData.childLineItems.length;i++){
                  childTotalCost += Number(programmaticPackageData.childLineItems[i]?.placementCost?.plannedCost?.amount || 0);
                  if(programmaticPackageData.childLineItems[i]?.childLineItems){
                    calculateChildTotals(programmaticPackageData.childLineItems[i]);
                  }
                }
              }
            }
            calculateChildTotals(programmaticPackageData);
            if (childTotalCost > totalCost) {
                AlertMessagesService.showInfoToastMessage(messages.programmaticCostAmount);
                return;
            }
        }
        this.setParameterCode(this.state.formData, true);
        
        // Determine whether to save a programmatic package or create a placement/package
        if(!this.props.editDailog){
          switch(true) {
            case this.DirectProgrammaticTypes.includes(this.props.placementCategory?.title):
            case this.state.programmaticPackageData && this.props.placementCategory?.title === 'Line Item':
            case this.state.programmaticPackageData && this.props.placementCategory?.title === 'Creative Placement':
            case this.state.programmaticPackageData && this.DirectProgrammaticMainTypes.includes(this.props.placementCategory?.type):
            case this.props.placementCategory?.taxonomyType === "DirectPackage" && this.props.selectedItems.length === 0:
              this.saveProgrammaticPackage(add_next);
              break;
            default:
              this.createPlacementOrPackage(add_next);
              break;
          }
        } else {
          this.createPlacementOrPackage(add_next);
        }
    }
  }

  // Modify your validateAllFieldsOnLoad to log more info
  validateAllFieldsOnLoad = () => {
    const { formData, taxonomyData } = this.state;
    
    if (!taxonomyData?.fields) {
      return false;
    }
    
    
    const errors = {};
    let hasErrors = false;
    
    // Check all fields in taxonomy data
    taxonomyData.fields.forEach(field => {
      const fieldName = field.field_name || field.name;
      const value = formData[fieldName] || '';
      
      // Space validation
      if (field.allowed_space === false && value.includes(' ')) {
        errors[fieldName] = true;
        hasErrors = true;
      }
      
      // Required field validation - keep this for completeness
      if ((field.required || this.requiredFields.includes(fieldName)) && !value) {
        errors[fieldName] = true;
        hasErrors = true;
      }
    });
    
    // Update error state if needed
    if (hasErrors) {
      this.setState({
        validationFlag: true,
        errorForm: { ...this.state.errorForm, ...errors }
      });
      
      // Update save button disabled state
      this.isSaveDisabled = true;
    }
    
    return hasErrors;
  }

  /**
   * The function 'overridePlacementName' will be called on click of edit Package/Line items name
   * Will update the required fields array by removing the placement taxanomy required fields
   */
  overridePlacementName = () => {
    let formData = {...this.state.formData}
    this.currentPlacementName = formData["Placement Name"];
    if(formData["Placement Name"]?.trim()){ // If placement name is not empty, set the isOverride flag to true and update the placement name with the override placement name
      formData['isOverride'] = true;
      formData['Override Placement Name'] = formData["Placement Name"];
    }
    this.setState({editPlacementName:true, formData}, () => {
      this.fieldIsUpdated = true;
      this.updaterequiredFields(this.props, true);
      this.isFormDirty(this.state.formData);
      this.createPlacementName(formData);
    });
  }

  /**
   * The function 'cancelOverride' will be called on click of cancel icon on Package/Line items name field.
   * Will update the placement name with the previous value
   * Will update the required fields array by adding the placement taxanomy required fields
   */
  cancelOverride = () => {
    let formData = {...this.state.formData};
    let errorForm = {...this.state.errorForm};
    errorForm["Placement Name"] = false;
    // Get the edit data and populate the form with the override placement name
    let taxonomySchema = CreateTaxonomyService.generateTaxonomySchema(this.state.taxonomyData)?.taxonomySchema;
    let editFormData = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(formData['Override Placement Name'], taxonomySchema, this.state.taxonomyData?.fields);
    let schemaArr = taxonomySchema.split("|");
    for (const index of schemaArr) {
      this.populateTaxonomyValues(index, editFormData[index], formData, this.state.taxonomyData?.fields);
    }
    formData['isOverride'] = false;
    formData['Override Placement Name'] = null;
    formData["Placement Name"] = this.currentPlacementName;
    this.setState({editPlacementName:false, formData:formData, errorForm:errorForm}, () => {
      this.fieldIsUpdated = true;
      this.updaterequiredFields(this.props, false);
      this.isFormDirty(this.state.formData);
      this.createPlacementName(formData);
    });
  }

  /**
   * if Direct or Social Direct package is being created and cancel on child modal then 'if' condtion will run and Package will created
   * Else modal will close without creating any Placement
   * @param {*} event curreent elment dom
   */
  cancelPlacementModal=()=>{
    if(!this.props.editDailog && this.state.programmaticPackageData &&  this.DirectProgrammaticMainTypes.includes(this.props.placementCategory?.type)){
      const programmaticPackageData = this.state.programmaticPackageData;
      this.addAnotherPlacementParent = {};
      this.setState({programmaticPackageData:programmaticPackageData, spinnerCount: 1});
      this.postPlacementOrPackage(programmaticPackageData,false,true, this.props.placementCategory?.type.includes('Social') ? 'Social Package' : 'Package');
    }else{
      this.setState({programmaticPackageData:null,programmaticPkgForm:null,formData: {},spinnerCount: 1});
      this.close();
    }
  }

  /**
   * Smart Suggestions - Open the suggestion panel
   */
  openSmartSuggestionPanel = () => {
    this.setState({ smartSuggestionPanelOpen: true });
  };

  /**
   * Smart Suggestions - Close the suggestion panel
   */
  closeSmartSuggestionPanel = () => {
    this.setState({ 
      smartSuggestionPanelOpen: false,
      showSmartSuggestions: false 
    });
  };

  /**
   * Smart Suggestions - Apply suggested values to form data
   */
  applySuggestedValues = (suggestedData) => {
    const formData = { ...this.state.formData };

    Object.entries(suggestedData).forEach(([fieldName, data]) => {
      formData[fieldName] = data.value;
    });

    this.setState({
      formData,
      showSmartSuggestions: false
    }, () => {
      this.createPlacementName(formData);
      this.isFormDirty(formData, this.props);
    });
  };

  /**
   * Smart Suggestions - Accept most recent values
   */
  acceptMostRecentValues = (mostRecentData) => {
    this.applySuggestedValues(mostRecentData);
  };

  /**
   * Smart Suggestions - Accept most frequent values
   */
  acceptMostFrequentValues = (mostFrequentData) => {
    this.applySuggestedValues(mostFrequentData);
  };

    /**
   * Adjusts the position of a dropdown element to ensure it is fully visible within the viewport.
   */
    adjustDropdownPosition() {
      const dropdownElement = document.querySelector(".adjust-dropdown");
     /**
     * Check if the dropdown element is present in the DOM.
     * If present, get the dropdown element's bounding rectangle and the window height.
     * Set the dropdown element's position to fixed.
     */
     if(dropdownElement){
      const dropdownRect = dropdownElement.getBoundingClientRect();
      const windowHeight = document.documentElement.clientHeight;
      const dropdownTopPosition = dropdownRect.top;
      const dropdownBottomPosition = dropdownRect.bottom;
      const modelRect = document.querySelector(".modal-content").getBoundingClientRect();
      const modelFooterHeight = document.querySelector(".message-footer").clientHeight
      const modelHeaderHeight = document.querySelector(".message-header").clientHeight
      const modelSubHeaderHeight = document.querySelector(".sub-header").clientHeight
  
  
      if(dropdownElement.shadowRoot !== null){
        const dropdownList = dropdownElement.shadowRoot.querySelector(".dropdown");
        if(dropdownList){
  
          if(dropdownTopPosition > modelRect.top+modelRect.height-(modelFooterHeight+10)){
            dropdownList.style.display = 'none'
          }else if(dropdownTopPosition < modelHeaderHeight+modelSubHeaderHeight){
            dropdownList.style.display = 'none'
          }else{
  
            dropdownList.style.display = 'block'
            
            if(dropdownRect.bottom + 200 + dropdownElement.offsetHeight >  windowHeight-modelRect.top) {
              dropdownList.style.top = 'auto'
              dropdownList.style.bottom = `${windowHeight - dropdownBottomPosition + dropdownElement.offsetHeight + 2}px`;
            } else {
              dropdownList.style.bottom = 'auto'
              dropdownList.style.top = `${dropdownTopPosition + dropdownElement.offsetHeight}px`;
            }
          }
        }
      }else if(dropdownElement.shadowRoot === null){
  
        const dropdownListTwo = dropdownElement.querySelector("om2-dropdown-impl").shadowRoot.querySelector(".dropdown-content");
  
        if(dropdownTopPosition > modelRect.top+modelRect.height - (modelFooterHeight+10)){
          dropdownListTwo.style.display = 'none'
        }else if(dropdownTopPosition < modelHeaderHeight+modelSubHeaderHeight+10){
          dropdownListTwo.style.display = 'none'
        }else{
          dropdownListTwo.style.display = 'block'
        }
      }
    }
    
  } 

  /**
   * if costmethod is selected as cpc then assign value to 'CPC Calculation Type'-
   * In case of Edit or creating new child placement from parent and parent had CPC in costMethod
   * @param {string} placement costMethod from placement parameter code
   * @returns 
   */
  getCpcCalculationType(costMethod,cpcCalcTypeValue){
    let cpcCalcType = ''
    if(costMethod === 'CPC'){
      cpcCalcType = cpcCalcTypeValue;
    }
    return cpcCalcType;
  }
  /**
   * After filling all value cost Amount function will create programmaticPackage in state 
   * and update formData state
   * both will use to create line item table
   */
  getProgramaticPayload(formData=null){
    formData = formData?formData:this.state.formData
    formData['taxonomy'] = this.state.taxonomySelectedValueJson;
    CreatePlacementOrPackageService.prepareCreatePackagePayload(
      formData,
      this.props.omniProfile,
      this.props.selectedItems,
      this.getPackageType(),
      this.state.taxonomyData
    ).then((payload) => {
      //Assiging value to programmaticPackageData to set state ,only then line item table will appeare,
      // if already set then checking child item exist then assiging programmaticPackageData with child(creative) to set state
      formData['programmaticType'] = this.props.placementCategory?.title
      let programmaticPackageData = [];
      if(this.state.programmaticPackageData?.length && this.state.programmaticPackageData[0].childLineItems?.length){
        //Asigning child (line item) if already created
        let lineItemPayload = this.state.programmaticPackageData[0].childLineItems;
        programmaticPackageData = payload;
        programmaticPackageData[0].childLineItems = lineItemPayload;
        let totalCost = programmaticPackageData[0].placementCost.plannedCost.amount;
        let childTotalCost = lineItemPayload.reduce((prev, curr, index, array) => curr?.placementCost? prev + Number(curr.placementCost.plannedCost.amount):0, 0);
        if(childTotalCost > totalCost){
          AlertMessagesService.showInfoToastMessage(messages.programmaticCostAmount);
        }
      }else{
        programmaticPackageData = payload;
      }
      //programatic value is use to assign to save payload reqest of progamatic package
      this.setState({programmaticPackageData:programmaticPackageData,formData:formData,programmaticFormData:formData }, () => {
        //To show alert if creative schema is missing, not required as creative creation is removed
        //this.alertOnMissingCreativeTaxonomy(programmaticPackageData)
      });
    });
  }

  /**
   * If Creative Schema is missing then this function will show Alert message
   */
  alertOnMissingCreativeTaxonomy(programmaticPackageData){
    let placementObject = {
      programmaticType : this.props.placementCategory?.type.includes('Social') ? 'Social Line Item' : 'Line Item',
      isOverride : programmaticPackageData[0].overrideTaxonomy
    }
    let isCreativeTaxonomyAvialable = PlacementUtils.checkCreativeTaxonomy(placementObject,this.props.allTaxonomyData);
    //this.state.showTaxonomyAlert is use so alert message should not repeat on every call. 
    if(!isCreativeTaxonomyAvialable){
        AlertMessagesService.showInfoToastMessage('Creative Taxonomy Schema is missing');
    }
  } 

  /**
   * function run through line table component when it return any value from table
   * @param {Object} lineItemPayload 
   */
  lineItemProgramatic = (lineItemPayload,isChange = false) => {
    const programmaticPackageData = this.state.programmaticPackageData;
    programmaticPackageData[0].childLineItems = lineItemPayload;
    this.setState({programmaticPackageData:programmaticPackageData});
    this.isFormDirty(this.state.formData);
    if(this.props.editDailog){
      if(!isChange){
        this.isSaveDisabled = isChange;
        this.fieldIsUpdated = !isChange;
      };
    }
  }

  /**
   * function is use to get type of child type of a programmatic package
   * @returns return Placement or Line Item
  */
  getProgrammaticChildType = () => {
    if(this.props.placementCategory?.type.includes('Social')){
      return this.props.allTaxonomyData.socialProgrammaticPlacementTaxonomyData?.fields?.length ? 'Placement' : 'Social Line Item';
    } else {
      return this.props.allTaxonomyData.programmaticPlacementTaxonomyData?.fields?.length ? 'Placement' : 'Line Item';
    }
  }

  /**
   * Returns a list of accordions for the taxonomy media mix section.
   * @returns {Array} A list of accordions.
   */
  renderPlacementLineAndChildTable = () => {
    return (
      <div className="line-and-child-table">
        { this.checkConditionforProgramaticAndSocialProgramatic() &&   
          <CreateLineAndChildPlacementTable
          programmaticformData={this.state.programmaticFormData}
          parentProps={this.props}  
          programmaticType={this.getProgrammaticChildType()}
          parentChildPlacements = {this.state.parentChildPlacements}
          lineItemProgramatic={this.lineItemProgramatic}
          campaignObj={this.props.campaignObj}
          systemParametersData={this.props.systemParametersData}
          socialProgrammaticFlag = {this.props.placementCategory?.type.includes('Social')}
          editDailog = {this.props.editDailog}
          placementCategory = {this.props.placementCategory}
          />
        }
      </div>
    ); 
  };

  /**
   * function is use to check condition if it progamatic or social proramatic
   * @returns return true if any of condtion match
   */
  checkConditionforProgramaticAndSocialProgramatic(){
    if(this.state.programmaticPackageData?.length){
      if(this.props.placementCategory?.title === "Package" && this.props.placementCategory?.type.includes('Programmatic')){
        return true
      }else if(this.props.placementCategory?.type.includes('Social') && this.props.placementCategory?.type.includes('Programmatic')){
        return true
      }
    }
    return false;
  }

  checkAdServerOrVerifocationFeeCards = (field) => {
    let hideClass = false;
    if(field.name == 'Ad Server' && !this.props?.rateAndFees?.adServer){
      hideClass = true;
    }else if(field.name == 'Ad Verification' && !this.props?.rateAndFees?.adVerification){
      hideClass = true;
    }
    return hideClass
  }
  render() {
    return (
      <>
        {(this.state.isPlacementModalOpen || this.props.isPlacementModalOpen)&& (
          <div className="placemnt-create modal is-active">
            <div className="modal-content" onClick={this.handleModalClick}>
              <LoaderComponent
                spinnerCount={this.state.spinnerCount}
                displayWholePage={true}
              />
              <article className="message">
                <div className="message-header">
                  <span className="object-title is-size-3 placement-modal-header-text">
                    {this.props.editDailog ? `Edit ` : `Create `}
                    {this.getHeaderName()}
                  </span>
                </div>
                
                {/* Smart Suggestions Banner */}
                {(() => {
                  const { editDailog, placementData } = this.props;
                  const { showSmartSuggestions } = this.state;
                  const isCreateDialog = !editDailog && showSmartSuggestions;
                  const isPlanitEditDialog = editDailog && 
                                             placementData?.data_source === 'planit' && 
                                             placementData?.pmds_package_name && 
                                             showSmartSuggestions;
                  const shouldShowBanner = isCreateDialog || isPlanitEditDialog;

                  return shouldShowBanner && (
                    <SmartSuggestionBanner 
                      onViewClick={this.openSmartSuggestionPanel}
                      metadata={this.state.smartSuggestionsData?.metadata}
                    />
                  );
                })()}
                {!!this.state.formData["PMDS Name"] &&
                  <div className="placement-create-container sub-header">
                    <span className="placement-create-Header">Planning System Name</span>
                    <div className="input-container p-0 placement-name">
                      <div className="full-width left-div editIcons">
                        <div className="full-width">
                          <input
                            id="name"
                            type="text"
                            className="input text full-width"
                            disabled
                            value={this.state.formData["PMDS Name"]}
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <div className="placement-create-container sub-header">
                  <span className="placement-create-Header">{this.getHeaderName()} name (Preview)</span>
                  <div className="input-container p-0 placement-name">
                    <div className="full-width left-div editIcons">
                      <div className="full-width">
                        <input
                          id="name"
                          type="text"
                          className="input text full-width"
                          disabled={!this.state.editPlacementName && this.state.taxonomyData}
                          onChange={(e) => this.onDataChange("Placement Name", e)}
                          value={this.state.formData["Placement Name"]}
                          maxLength={this.placementMaxCharLimit}
                          placeholder={this.state.taxonomyData && `${this.getHeaderName()} name is auto-generated via taxonomy details below`}
                        ></input>
                      </div>
                      {this.state.taxonomyData && <div className="right-div synthetic-id-label">
                        <label>Synthetic ID</label>
                        <input
                          className="input text full-width synthetic-text"
                          disabled
                          value={this.synthecticId}
                        ></input>
                      </div>}
                    </div>
                    {this.state.taxonomyData && !this.state.editPlacementName &&
                      <OmniTooltipNextComponent>
                        <button onClick={this.overridePlacementName} slot="invoker" aria-haspopup="true" className="icon">
                          <OmniIconComponent className="is-size-2 header-icon" icon-id="omni:interactive:edit" />
                        </button>
                        <div slot="content">Override {this.getHeaderName()} name</div>
                      </OmniTooltipNextComponent>
                    }
                    {this.state.taxonomyData && this.state.editPlacementName &&
                      <OmniTooltipNextComponent>
                        <button onClick={this.cancelOverride} slot="invoker" aria-haspopup="true" className="icon">
                          <OmniIconComponent className="is-size-2 header-icon" icon-id="omni:interactive:reset" />
                        </button>
                        <div slot="content">Cancel Override</div>
                      </OmniTooltipNextComponent>
                    }
                  </div>
                </div>
                {this.state.errorForm["Placement Name"] && (
                  <span className="errorContainer">
                    <omni-icon class="is-size-4 errorIcon" icon-id="omni:informative:error"></omni-icon>
                    {this.state.errorForm["Placement Name"] === "charlimitexceeds" ? <span className="errorText">Character limit ({this.placementMaxCharLimit}) exceeded</span> : <span className="errorText">Wrong format entry, see info</span>}
                  </span>
                )}
                <div className="message-body" onScroll={this.adjustDropdownPosition}>
                  <div className="separater"></div>
                  <div className="placement-create-container">
                    {this.getTaxanomyMediaMixAccordion()}
                  </div>
                  <div className="placement-line-Child-container">
                    {this.renderPlacementLineAndChildTable()}
                  </div>
                </div>
                <div className="message-footer">
                  {(this.isSaveDisabled && this.state.emptyFieldError && !this.state.errorForm['Placement Name']) && 
                    <span className="footer-error-message">* Indicates mandatory fields (In case of Programmatic Package, Please add atleast one child items by clicking on Calculate button before saving)</span>
                  }
                  <button className="tertiary" onClick={() => this.cancelPlacementModal()}>
                    Cancel
                  </button>
                  {!this.props.editDailog && this.props.placementCategory?.title !== 'Package' && (
                    <button className="secondary" onClick={() => this.saveOrUpdate(true, this.isSaveDisabled)}>
                      Save and Add another
                    </button>
                  )}
                  <button onClick={() => this.saveOrUpdate(false, this.isSaveDisabled)}>
                    {this.props.placementCategory?.title === 'Package' ? (this.props.editDailog ? "Update package" : "Create package") : (this.props.editDailog ? "Update" : "Create")}
                  </button>
                </div>
              </article>
            </div>
          </div>
        )}
        
        {/* Smart Suggestions Panel */}
        <SmartSuggestionPanel 
          isOpen={this.state.smartSuggestionPanelOpen}
          onClose={this.closeSmartSuggestionPanel}
          suggestionsData={this.state.smartSuggestionsData}
          onAcceptRecent={this.acceptMostRecentValues}
          onAcceptFrequent={this.acceptMostFrequentValues}
        />
      </>
    );
  }
}

